(self["webpackChunk_N_E"] = self["webpackChunk_N_E"] || []).push([[5729,2576,5124,949,9600,8960],{

/***/ 92090:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
// ESM COMPAT FLAG
__webpack_require__.r(__webpack_exports__);

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "default": function() { return /* binding */ customerai_predictions; }
});

// EXTERNAL MODULE: ../../libs/matcha/foundations/AppearanceContext/index.ts + 1 modules
var AppearanceContext = __webpack_require__(9381);
// EXTERNAL MODULE: ../../libs/templates/Footer/index.ts
var Footer = __webpack_require__(4009);
// EXTERNAL MODULE: ../../libs/templates/Navigation/index.ts + 91 modules
var Navigation = __webpack_require__(87303);
// EXTERNAL MODULE: ../../libs/templates/GettingStarted/index.ts + 2 modules
var GettingStarted = __webpack_require__(42576);
// EXTERNAL MODULE: ../../libs/templates/DividerSection/index.ts
var DividerSection = __webpack_require__(85507);
// EXTERNAL MODULE: ../../libs/next-shared/layout/index.ts
var layout = __webpack_require__(56052);
// EXTERNAL MODULE: ../../node_modules/@emotion/styled/base/dist/emotion-styled-base.browser.esm.js
var emotion_styled_base_browser_esm = __webpack_require__(92952);
// EXTERNAL MODULE: ../../libs/matcha/recipes/CopyText/index.ts + 2 modules
var CopyText = __webpack_require__(94136);
// EXTERNAL MODULE: ../../libs/matcha/recipes/Hero/index.tsx + 2 modules
var recipes_Hero = __webpack_require__(84629);
// EXTERNAL MODULE: ../../libs/templates/Forms/DemoForm/index.ts + 3 modules
var DemoForm = __webpack_require__(98960);
// EXTERNAL MODULE: ../../libs/matcha/components/Image/index.ts + 2 modules
var Image = __webpack_require__(4203);
// EXTERNAL MODULE: ./src/views/CustomerAIPredictions/components/Hero/assets/Hero@2x.png
var Hero_2x = __webpack_require__(63988);
var Hero_2x_default = /*#__PURE__*/__webpack_require__.n(Hero_2x);
// EXTERNAL MODULE: ./src/views/CustomerAIPredictions/components/Hero/assets/Hero.webp
var Hero = __webpack_require__(39493);
var Hero_default = /*#__PURE__*/__webpack_require__.n(Hero);
// EXTERNAL MODULE: ./src/views/CustomerAIPredictions/components/Hero/assets/Hero@2x.webp
var assets_Hero_2x = __webpack_require__(24217);
var assets_Hero_2x_default = /*#__PURE__*/__webpack_require__.n(assets_Hero_2x);
// EXTERNAL MODULE: ../../node_modules/@emotion/react/jsx-runtime/dist/emotion-react-jsx-runtime.browser.esm.js
var emotion_react_jsx_runtime_browser_esm = __webpack_require__(52903);
;// CONCATENATED MODULE: ./src/views/CustomerAIPredictions/components/Hero/HeroImage.tsx







var HeroImage = function HeroImage() {
  return (0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)("picture", {
    children: [(0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)("source", {
      type: "image/webp",
      srcSet: "".concat((Hero_default()), ", ").concat((assets_Hero_2x_default()), " 2x")
    }), (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(Image/* default */.Z, {
      width: "630",
      height: "541",
      src: (Hero_2x_default()),
      alt: "Hero image",
      loading: "lazy"
    })]
  });
};

/* harmony default export */ var Hero_HeroImage = (HeroImage);
;// CONCATENATED MODULE: ./src/views/CustomerAIPredictions/components/Hero/Hero.tsx







var copy = {
  overline: "CustomerAI Predictions",
  heading: "Put the power of predictive AI in the hands of your marketer",
  description: "Easily predict future customer behavior to deliver precise and personalized campaigns without needing to tap data science teams.",
  buttonText: "Get a demo"
};

var Hero_Hero = function Hero() {
  return (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(Wrapper, {
    children: (0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)(recipes_Hero/* default */.ZP, {
      variant: "2Col",
      children: [(0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)(recipes_Hero/* Copy */.CK, {
        children: [(0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)(CopyText/* default */.ZP, {
          children: [(0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(CopyText/* Overline */.Lh, {
            variant: "overline",
            tag: "span",
            children: copy.overline
          }), (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(CopyText/* Heading */.X6, {
            variant: "h1",
            tag: "h1",
            children: copy.heading
          }), (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(CopyText/* Description */.dk, {
            variant: "pExtraLarge",
            tag: "h2",
            children: copy.description
          })]
        }), (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(recipes_Hero/* Form */.l0, {
          children: (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(DemoForm/* default */.Z, {
            isProgressive: true,
            customFormIdentifier: "site-customerai-predictions-demo",
            customTrackingType: "site-customerai-predictions-demo",
            successMessageAppearance: "twilioLight"
          })
        })]
      }), (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(recipes_Hero/* Contents */.AU, {
        children: (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(Hero_HeroImage, {})
      })]
    })
  });
};

var Wrapper = /*#__PURE__*/(0,emotion_styled_base_browser_esm/* default */.Z)("header",  true ? {
  target: "e15azc4d0"
} : 0)("position:relative;z-index:0;background-color:", function (_ref) {
  var theme = _ref.theme;
  return theme.palette.twilio.green[10];
}, ";" + ( true ? "" : 0));

/* harmony default export */ var components_Hero_Hero = (Hero_Hero);
// EXTERNAL MODULE: ../../libs/matcha/recipes/Section/index.ts + 2 modules
var Section = __webpack_require__(88392);
// EXTERNAL MODULE: ./src/views/CustomerAIPredictions/components/PredictiveAudiences/assets/PredictiveAudiences@2x.png
var PredictiveAudiences_2x = __webpack_require__(94582);
var PredictiveAudiences_2x_default = /*#__PURE__*/__webpack_require__.n(PredictiveAudiences_2x);
// EXTERNAL MODULE: ./src/views/CustomerAIPredictions/components/PredictiveAudiences/assets/PredictiveAudiences.webp
var PredictiveAudiences = __webpack_require__(12019);
var PredictiveAudiences_default = /*#__PURE__*/__webpack_require__.n(PredictiveAudiences);
// EXTERNAL MODULE: ./src/views/CustomerAIPredictions/components/PredictiveAudiences/assets/PredictiveAudiences@2x.webp
var assets_PredictiveAudiences_2x = __webpack_require__(6758);
var assets_PredictiveAudiences_2x_default = /*#__PURE__*/__webpack_require__.n(assets_PredictiveAudiences_2x);
;// CONCATENATED MODULE: ./src/views/CustomerAIPredictions/components/PredictiveAudiences/PredictiveAudiencesImage.tsx







var PredictiveAudiencesImage = function PredictiveAudiencesImage() {
  return (0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)("picture", {
    children: [(0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)("source", {
      type: "image/webp",
      srcSet: "".concat((PredictiveAudiences_default()), ", ").concat((assets_PredictiveAudiences_2x_default()), " 2x")
    }), (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(Image/* default */.Z, {
      src: (PredictiveAudiences_2x_default()),
      alt: "Predictive Audiences image",
      width: "562",
      height: "412",
      loading: "lazy"
    })]
  });
};

/* harmony default export */ var PredictiveAudiences_PredictiveAudiencesImage = (PredictiveAudiencesImage);
;// CONCATENATED MODULE: ./src/views/CustomerAIPredictions/components/PredictiveAudiences/PredictiveAudiences.tsx






var PredictiveAudiences_copy = {
  title: "Say goodbye to guesswork and hello to precise personalization",
  description: "CustomerAI Predictions gives marketers the power of predictive AI, making it easy to uncover patterns in historical customer data, predict future behavior, and discover audiences primed for engagement\u2014saving teams time, boosting campaign performance, and improving personalization."
};

var PredictiveAudiences_PredictiveAudiences = function PredictiveAudiences() {
  return (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(PredictiveAudiences_Wrapper, {
    children: (0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)(Section/* default */.ZP, {
      variant: "2Col",
      reverse: true,
      children: [(0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(Section/* Copy */.CK, {
        alignSelf: "center",
        children: (0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)(CopyText/* default */.ZP, {
          children: [(0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(CopyText/* Heading */.X6, {
            variant: "h2",
            tag: "h2",
            children: PredictiveAudiences_copy.title
          }), (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(CopyText/* Description */.dk, {
            variant: "pLarge",
            tag: "p",
            children: PredictiveAudiences_copy.description
          })]
        })
      }), (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(Section/* Contents */.AU, {
        children: (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(PredictiveAudiences_PredictiveAudiencesImage, {})
      })]
    })
  });
};

var PredictiveAudiences_Wrapper = /*#__PURE__*/(0,emotion_styled_base_browser_esm/* default */.Z)("div",  true ? {
  target: "ecllknr0"
} : 0)("background-color:", function (_ref) {
  var theme = _ref.theme;
  return theme.palette.neutrals.white[100];
}, ";max-width:1440px;margin:0 auto;" + ( true ? "" : 0));

/* harmony default export */ var components_PredictiveAudiences_PredictiveAudiences = (PredictiveAudiences_PredictiveAudiences);
// EXTERNAL MODULE: ../../libs/matcha/components/ColumnTrack/index.ts + 2 modules
var ColumnTrack = __webpack_require__(85735);
// EXTERNAL MODULE: ./src/views/CustomerAIPredictions/components/PredictiveAIModels/assets/PredictiveAIModels@2x.png
var PredictiveAIModels_2x = __webpack_require__(92941);
var PredictiveAIModels_2x_default = /*#__PURE__*/__webpack_require__.n(PredictiveAIModels_2x);
// EXTERNAL MODULE: ./src/views/CustomerAIPredictions/components/PredictiveAIModels/assets/PredictiveAIModels.webp
var PredictiveAIModels = __webpack_require__(20625);
var PredictiveAIModels_default = /*#__PURE__*/__webpack_require__.n(PredictiveAIModels);
// EXTERNAL MODULE: ./src/views/CustomerAIPredictions/components/PredictiveAIModels/assets/PredictiveAIModels@2x.webp
var assets_PredictiveAIModels_2x = __webpack_require__(96256);
var assets_PredictiveAIModels_2x_default = /*#__PURE__*/__webpack_require__.n(assets_PredictiveAIModels_2x);
;// CONCATENATED MODULE: ./src/views/CustomerAIPredictions/components/PredictiveAIModels/PredictiveAIModelsImage.tsx







var PredictiveAIModelsImage = function PredictiveAIModelsImage() {
  return (0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)("picture", {
    children: [(0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)("source", {
      type: "image/webp",
      srcSet: "".concat((PredictiveAIModels_default()), ", ").concat((assets_PredictiveAIModels_2x_default()), " 2x")
    }), (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(Image/* default */.Z, {
      src: (PredictiveAIModels_2x_default()),
      alt: "Predictive AIModels image",
      width: "596",
      height: "404",
      loading: "lazy"
    })]
  });
};

/* harmony default export */ var PredictiveAIModels_PredictiveAIModelsImage = (PredictiveAIModelsImage);
;// CONCATENATED MODULE: ./src/views/CustomerAIPredictions/components/PredictiveAIModels/PredictiveAIModels.tsx


function _EMOTION_STRINGIFIED_CSS_ERROR__() { return "You have tried to stringify object returned from `css` function. It isn't supposed to be used directly (e.g. as value of the `className` prop), but rather handed to emotion so it can handle it (e.g. as value of `css` prop)."; }








var PredictiveAIModels_copy = {
  heading: "Elevate every customer interaction with user-friendly predictive AI",
  description: "CustomerAI Predictions gives marketers easy-to-use, out-of-the-box predictive models built on trusted, AI-ready data in Segment to quickly create Predictive Traits that get added to the customer profile to power more timely, targeted, and precisely personalized customer experiences on every channel.",
  list: [{
    title: "Likelihood to Purchase",
    description: "Predict the propensity of customers to make a purchase."
  }, {
    title: "Likelihood to Churn",
    description: "Proactively identify customers who are likely to stop using your product."
  }, {
    title: "Predicted Lifetime Value (LTV)",
    description: "Predict a customer's future spend over the next 90 days."
  }, {
    title: "Custom Predictive Goals",
    description: "Predict the propensity of customers to perform any event tracked in Segment (e.g. likelihood to use a promo code or refer a friend)."
  }]
};

var PredictiveAIModels_PredictiveAIModels = function PredictiveAIModels() {
  return (0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)(emotion_react_jsx_runtime_browser_esm/* Fragment */.HY, {
    children: [(0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(Section/* default */.ZP, {
      variant: "centered",
      children: (0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)(StyledCopyTextBase, {
        centered: true,
        children: [(0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(CopyText/* Heading */.X6, {
          tag: "h2",
          children: PredictiveAIModels_copy.heading
        }), (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(CopyText/* Description */.dk, {
          tag: "p",
          variant: "pLarge",
          children: PredictiveAIModels_copy.description
        })]
      })
    }), (0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)(Section/* default */.ZP, {
      variant: "2Col",
      children: [(0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(Section/* Copy */.CK, {
        children: (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(ColumnTrack/* default */.Z, {
          children: PredictiveAIModels_copy.list.map(function (_ref, key) {
            var title = _ref.title,
                description = _ref.description;
            return (0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)(CopyText/* default */.ZP, {
              children: [(0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(CopyText/* Heading */.X6, {
                tag: "h3",
                variant: "h5",
                children: title
              }), (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(CopyText/* Description */.dk, {
                tag: "p",
                children: description
              })]
            }, key);
          })
        })
      }), (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(Section/* Contents */.AU, {
        children: (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(PredictiveAIModels_PredictiveAIModelsImage, {})
      })]
    })]
  });
};

var StyledCopyTextBase = /*#__PURE__*/(0,emotion_styled_base_browser_esm/* default */.Z)(CopyText/* default */.ZP,  true ? {
  target: "el5jdvq0"
} : 0)( true ? {
  name: "1ib8u6k",
  styles: "max-width:844px"
} : 0);

/* harmony default export */ var components_PredictiveAIModels_PredictiveAIModels = (PredictiveAIModels_PredictiveAIModels);
// EXTERNAL MODULE: ../../libs/matcha/components/ButtonText/index.ts
var ButtonText = __webpack_require__(74870);
// EXTERNAL MODULE: ../../libs/matcha/components/Icons/Common.ts + 14 modules
var Common = __webpack_require__(6580);
// EXTERNAL MODULE: ../../libs/matcha/recipes/Card/index.ts + 31 modules
var Card = __webpack_require__(74881);
;// CONCATENATED MODULE: ./src/views/CustomerAIPredictions/components/Resources/Resources.tsx


function Resources_EMOTION_STRINGIFIED_CSS_ERROR_() { return "You have tried to stringify object returned from `css` function. It isn't supposed to be used directly (e.g. as value of the `className` prop), but rather handed to emotion so it can handle it (e.g. as value of `css` prop)."; }









var data = [{
  type: "Webinar",
  title: "No Code Required: CustomerAI Predictions in Action.",
  content: "Learn how trusted customer data unlocks the promise of AI to drive adaptive engagement across your entire business\u2014helping you anticipate and act on future customer wants and needs and create more relevant customer experiences in minutes. ",
  ctaTitle: "View the webinar",
  ctaUrl: "https://webinars.segment.com/segment/No-Code-Required-CustomerAI-Predictions-in-Action"
}, {
  type: "Recipe",
  title: "Use Twilio Segment to Anticipate a Customer's Readiness to Buy",
  content: "In the competitive landscape of the FinTech industry, understanding customer behavior and predicting their readin...",
  ctaTitle: "Use this recipe",
  ctaUrl: "https://segment.com/recipes/use-segment-anticipate-readiness-to-buy/"
}, {
  type: "Segment University",
  title: "Use Predictions to Predict Customer Behavior",
  content: "Unlock insights into customer behavior, fine-tune marketing efforts, and maximize revenue opportunities with Predictions.",
  ctaTitle: "View this course",
  ctaUrl: "https://university.segment.com/use-predictions-to-predict-customer-behavior"
}];
var TITLE = "Resources";

var Resources = function Resources() {
  return (0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)(Section/* default */.ZP, {
    variant: "centered",
    children: [(0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(Section/* Copy */.CK, {
      children: (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(CopyText/* default */.ZP, {
        centered: true,
        children: (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(CopyText/* Heading */.X6, {
          tag: "h2",
          children: TITLE
        })
      })
    }), (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(Section/* Contents */.AU, {
      children: (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(StyledColumnTrack, {
        columns: 1,
        overrides: {
          lg: 3
        },
        children: data.map(function (_ref, key) {
          var type = _ref.type,
              title = _ref.title,
              content = _ref.content,
              ctaTitle = _ref.ctaTitle,
              ctaUrl = _ref.ctaUrl;
          return (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(Card/* default */.ZP, {
            href: ctaUrl,
            children: (0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)(Card/* Body */.uT, {
              children: [(0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(Card/* Accessories */.v8, {
                children: (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(Card/* AccessoriesRow */.OW, {
                  children: (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(Card/* Label */.__, {
                    children: type
                  })
                })
              }), (0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)(Card/* Copy */.CK, {
                children: [(0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(Card/* Headline */.s0, {
                  tag: "h3",
                  children: title
                }), (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(Card/* Description */.dk, {
                  children: content
                })]
              }), (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(Card/* Action */.aU, {
                alignment: "left",
                children: (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(ButtonText/* default */.Z, {
                  iconEnd: Common/* ChevronRightIcon */.XC,
                  children: ctaTitle
                })
              })]
            })
          }, key);
        })
      })
    })]
  });
};

var StyledColumnTrack = /*#__PURE__*/(0,emotion_styled_base_browser_esm/* default */.Z)(ColumnTrack/* default */.Z,  true ? {
  target: "e1849wrk0"
} : 0)( true ? {
  name: "xw24us",
  styles: "max-width:1120px;margin:0 auto"
} : 0);

/* harmony default export */ var Resources_Resources = (Resources);
// EXTERNAL MODULE: ../../libs/templates/Testimonial/index.ts + 2 modules
var Testimonial = __webpack_require__(5099);
;// CONCATENATED MODULE: ./src/views/CustomerAIPredictions/components/SingleTestimonial/SingleTestimonial.tsx


function SingleTestimonial_EMOTION_STRINGIFIED_CSS_ERROR_() { return "You have tried to stringify object returned from `css` function. It isn't supposed to be used directly (e.g. as value of the `className` prop), but rather handed to emotion so it can handle it (e.g. as value of `css` prop)."; }





var SingleTestimonial = function SingleTestimonial() {
  return (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(Section/* default */.ZP, {
    variant: "noCopy",
    children: (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(Section/* Contents */.AU, {
      children: (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(TestimonialWrapper, {
        children: (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(Testimonial/* default */.Z, {
          company: "box"
        })
      })
    })
  });
};

var TestimonialWrapper = /*#__PURE__*/(0,emotion_styled_base_browser_esm/* default */.Z)("div",  true ? {
  target: "e1hibstq0"
} : 0)( true ? {
  name: "ufm5d5",
  styles: "max-width:900px;margin:0 auto"
} : 0);

/* harmony default export */ var SingleTestimonial_SingleTestimonial = (SingleTestimonial);
// EXTERNAL MODULE: ../../libs/matcha/components/Typography/index.ts
var Typography = __webpack_require__(89533);
// EXTERNAL MODULE: ./src/views/CustomerAIPredictions/components/TrustIn/assets/DashboardExplore@2x.png
var DashboardExplore_2x = __webpack_require__(24631);
var DashboardExplore_2x_default = /*#__PURE__*/__webpack_require__.n(DashboardExplore_2x);
;// CONCATENATED MODULE: ./src/views/CustomerAIPredictions/components/TrustIn/assets/DashboardExplore.webp
/* harmony default export */ var DashboardExplore = ("data:image/webp;base64,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");
// EXTERNAL MODULE: ./src/views/CustomerAIPredictions/components/TrustIn/assets/DashboardExplore@2x.webp
var assets_DashboardExplore_2x = __webpack_require__(80681);
var assets_DashboardExplore_2x_default = /*#__PURE__*/__webpack_require__.n(assets_DashboardExplore_2x);
// EXTERNAL MODULE: ./src/views/CustomerAIPredictions/components/TrustIn/assets/DashboardUnderstand@2x.png
var DashboardUnderstand_2x = __webpack_require__(57692);
var DashboardUnderstand_2x_default = /*#__PURE__*/__webpack_require__.n(DashboardUnderstand_2x);
// EXTERNAL MODULE: ./src/views/CustomerAIPredictions/components/TrustIn/assets/DashboardUnderstand.webp
var DashboardUnderstand = __webpack_require__(92122);
var DashboardUnderstand_default = /*#__PURE__*/__webpack_require__.n(DashboardUnderstand);
// EXTERNAL MODULE: ./src/views/CustomerAIPredictions/components/TrustIn/assets/DashboardUnderstand@2x.webp
var assets_DashboardUnderstand_2x = __webpack_require__(88669);
var assets_DashboardUnderstand_2x_default = /*#__PURE__*/__webpack_require__.n(assets_DashboardUnderstand_2x);
;// CONCATENATED MODULE: ./src/views/CustomerAIPredictions/components/TrustIn/TrustIn.tsx


function TrustIn_EMOTION_STRINGIFIED_CSS_ERROR_() { return "You have tried to stringify object returned from `css` function. It isn't supposed to be used directly (e.g. as value of the `className` prop), but rather handed to emotion so it can handle it (e.g. as value of `css` prop)."; }















var DashboardExploreImage = function DashboardExploreImage() {
  return (0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)(Picture, {
    children: [(0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)("source", {
      type: "image/webp",
      srcSet: "".concat(DashboardExplore, ", ").concat((assets_DashboardExplore_2x_default()), " 2x")
    }), (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(Image/* default */.Z, {
      width: "536",
      height: "340",
      src: (DashboardExplore_2x_default()),
      alt: "Dashboard Explore image",
      loading: "lazy"
    })]
  });
};

var DashboardUnderstandImage = function DashboardUnderstandImage() {
  return (0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)(Picture, {
    children: [(0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)("source", {
      type: "image/webp",
      srcSet: "".concat((DashboardUnderstand_default()), ", ").concat((assets_DashboardUnderstand_2x_default()), " 2x")
    }), (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(Image/* default */.Z, {
      width: "536",
      height: "340",
      src: (DashboardUnderstand_2x_default()),
      alt: "Dashboard Understand image",
      loading: "lazy"
    })]
  });
};

var TrustIn_copy = {
  title: "Trust in our predictions with model transparency",
  description: "CustomerAI Predictions provides transparency into every prediction you create, so your marketing and data teams always feel confident in your predictions.",
  columns: [{
    image: (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(DashboardExploreImage, {}),
    title: (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(CopyText/* default */.ZP, {
      children: (0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)(CopyText/* Description */.dk, {
        variant: "pLarge",
        children: [(0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(Typography/* default */.Z, {
          tag: "b",
          variant: "pLargeBold",
          children: "The Explore view"
        }), " ", "visualizes the prediction data and lets marketers easily cohort that data to create audiences for targeted campaigns or customer journeys."]
      })
    })
  }, {
    image: (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(DashboardUnderstandImage, {}),
    title: (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(CopyText/* default */.ZP, {
      children: (0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)(CopyText/* Description */.dk, {
        variant: "pLarge",
        children: [(0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(Typography/* default */.Z, {
          tag: "b",
          variant: "pLargeBold",
          children: "The Understanding view"
        }), " ", "offers insights into all the underlying data points and how they contribute to the model."]
      })
    })
  }]
};

var TrustIn = function TrustIn() {
  return (0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)(Section/* default */.ZP, {
    variant: "centered",
    children: [(0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(Section/* Copy */.CK, {
      children: (0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)(CopyText/* default */.ZP, {
        centered: true,
        children: [(0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(CopyText/* Heading */.X6, {
          tag: "h2",
          children: TrustIn_copy.title
        }), (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(CopyText/* Description */.dk, {
          tag: "p",
          variant: "pLarge",
          children: TrustIn_copy.description
        })]
      })
    }), (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(Section/* Contents */.AU, {
      children: (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(TrustIn_StyledColumnTrack, {
        columns: 1,
        overrides: {
          md: 2
        },
        children: TrustIn_copy.columns.map(function (_ref, key) {
          var image = _ref.image,
              title = _ref.title;
          return (0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)(TrustIn_Wrapper, {
            children: [image, (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(CopyTextWrapper, {
              children: title
            })]
          }, key);
        })
      })
    })]
  });
};

var Picture = /*#__PURE__*/(0,emotion_styled_base_browser_esm/* default */.Z)("picture",  true ? {
  target: "evt76453"
} : 0)("filter:drop-shadow(", function (_ref2) {
  var theme = _ref2.theme;
  return theme.shadows[2];
}, ");" + ( true ? "" : 0));

var CopyTextWrapper = /*#__PURE__*/(0,emotion_styled_base_browser_esm/* default */.Z)("div",  true ? {
  target: "evt76452"
} : 0)( true ? {
  name: "3hgi0y",
  styles: "margin-top:32px"
} : 0);

var TrustIn_Wrapper = /*#__PURE__*/(0,emotion_styled_base_browser_esm/* default */.Z)("div",  true ? {
  target: "evt76451"
} : 0)( true ? "" : 0);

var TrustIn_StyledColumnTrack = /*#__PURE__*/(0,emotion_styled_base_browser_esm/* default */.Z)(ColumnTrack/* default */.Z,  true ? {
  target: "evt76450"
} : 0)( true ? {
  name: "xw24us",
  styles: "max-width:1120px;margin:0 auto"
} : 0);

/* harmony default export */ var TrustIn_TrustIn = (TrustIn);
// EXTERNAL MODULE: ../../libs/matcha/components/FeatureBox/index.ts
var FeatureBox = __webpack_require__(33514);
// EXTERNAL MODULE: ../../libs/matcha/components/Icons/Brandbook.ts + 93 modules
var Brandbook = __webpack_require__(52065);
// EXTERNAL MODULE: ../../libs/matcha/components/IconWrapper/index.ts + 2 modules
var IconWrapper = __webpack_require__(79600);
;// CONCATENATED MODULE: ./src/views/CustomerAIPredictions/components/BoostCampaign/BoostCampaign.tsx


function BoostCampaign_EMOTION_STRINGIFIED_CSS_ERROR_() { return "You have tried to stringify object returned from `css` function. It isn't supposed to be used directly (e.g. as value of the `className` prop), but rather handed to emotion so it can handle it (e.g. as value of `css` prop)."; }









var BoostCampaign_data = [{
  icon: (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(Brandbook/* TargetIcon */.cK, {}),
  title: "Improve ad targeting and return on ad spend (ROAS)",
  description: "Build lookalike audiences based on customers with a high likelihood to purchase or high LTV. Suppress ads to users with low likelihood to purchase or low LTV to conserve ad spend."
}, {
  icon: (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(Brandbook/* AnnouncementIcon */.HR, {}),
  title: "Increase performance of promotional and lifecycle campaigns",
  description: "Create more personalized emails, SMS, WhatsApp, and push notifications for customers no matter where they are in their journey or which buying groups they are in\u2014like discount vs full-price buyers."
}, {
  icon: (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(Brandbook/* UserIcon */.tB, {}),
  title: "Personalize online experiences",
  description: "Update your web and mobile experiences to showcase different products or promotions based on their propensity to purchase or engage with your content."
}, {
  icon: (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(Brandbook/* RaiseIcon */.xD, {}),
  title: "Boost upsell and cross-sell",
  description: "Drive greater upsell and cross-sell opportunities by launching timely campaigns showcasing personalized items when customers are most likely to buy."
}, {
  icon: (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(Brandbook/* CertificateIcon */.B, {}),
  title: "Enhance loyalty programs",
  description: "Quickly spot customers with high predicted LTV to invite into VIP loyalty programs or send special personalized offers."
}, {
  icon: (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(Brandbook/* EngagingIcon */.h, {}),
  title: "Bolster win-back campaigns",
  description: "Proactively identify disengaged or at-risk customers for targeted win-back and retention campaigns."
}];
var BoostCampaign_copy = {
  title: "Boost campaign performance and ROI",
  description: "Easily identify, target, and launch campaigns for users who are most likely to convert or take a desired action across all your customer channels and journeys."
};

var BoostCampaign = function BoostCampaign() {
  return (0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)(Section/* default */.ZP, {
    variant: "centered",
    children: [(0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(Section/* Copy */.CK, {
      children: (0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)(CopyText/* default */.ZP, {
        centered: true,
        children: [(0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(CopyText/* Heading */.X6, {
          tag: "h2",
          children: BoostCampaign_copy.title
        }), (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(CopyText/* Description */.dk, {
          tag: "p",
          variant: "pLarge",
          children: BoostCampaign_copy.description
        })]
      })
    }), (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(Section/* Contents */.AU, {
      children: (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(BoostCampaign_StyledColumnTrack, {
        columns: 1,
        overrides: {
          md: 3
        },
        children: BoostCampaign_data.map(function (_ref, key) {
          var icon = _ref.icon,
              title = _ref.title,
              description = _ref.description;
          return (0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)(FeatureBox/* default */.ZP, {
            alignment: "left",
            headerPosition: "top",
            children: [(0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(FeatureBox/* Header */.h4, {
              children: (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(StyledIconWrapper, {
                background: "light",
                elevation: 1,
                variant: "circle",
                children: icon
              })
            }), (0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)(FeatureBox/* Body */.uT, {
              children: [(0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(FeatureBox/* Title */.Dx, {
                children: title
              }), (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(FeatureBox/* Text */.xv, {
                children: description
              })]
            })]
          }, key);
        })
      })
    })]
  });
};

var StyledIconWrapper = /*#__PURE__*/(0,emotion_styled_base_browser_esm/* default */.Z)(IconWrapper/* default */.Z,  true ? {
  target: "eunlp4j1"
} : 0)("background-color:", function (_ref2) {
  var theme = _ref2.theme;
  return theme.palette.neutrals.white[100];
}, ";color:", function (_ref3) {
  var theme = _ref3.theme;
  return theme.palette.twilio.gray[100];
}, ";" + ( true ? "" : 0));

var BoostCampaign_StyledColumnTrack = /*#__PURE__*/(0,emotion_styled_base_browser_esm/* default */.Z)(ColumnTrack/* default */.Z,  true ? {
  target: "eunlp4j0"
} : 0)( true ? {
  name: "xw24us",
  styles: "max-width:1120px;margin:0 auto"
} : 0);

/* harmony default export */ var BoostCampaign_BoostCampaign = (BoostCampaign);
// EXTERNAL MODULE: ./src/views/CustomerAIPredictions/components/DiscoverAndActivate/assets/DiscoverAndActivate@2x.png
var DiscoverAndActivate_2x = __webpack_require__(75855);
var DiscoverAndActivate_2x_default = /*#__PURE__*/__webpack_require__.n(DiscoverAndActivate_2x);
// EXTERNAL MODULE: ./src/views/CustomerAIPredictions/components/DiscoverAndActivate/assets/DiscoverAndActivate@2x.webp
var assets_DiscoverAndActivate_2x = __webpack_require__(13675);
var assets_DiscoverAndActivate_2x_default = /*#__PURE__*/__webpack_require__.n(assets_DiscoverAndActivate_2x);
// EXTERNAL MODULE: ./src/views/CustomerAIPredictions/components/DiscoverAndActivate/assets/DiscoverAndActivate.webp
var DiscoverAndActivate = __webpack_require__(86331);
var DiscoverAndActivate_default = /*#__PURE__*/__webpack_require__.n(DiscoverAndActivate);
;// CONCATENATED MODULE: ./src/views/CustomerAIPredictions/components/DiscoverAndActivate/DiscoverAndActivateImage.tsx







var DiscoverAndActivateImage = function DiscoverAndActivateImage() {
  return (0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)("picture", {
    children: [(0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)("source", {
      type: "image/webp",
      srcSet: "".concat((DiscoverAndActivate_default()), ", ").concat((assets_DiscoverAndActivate_2x_default()), " 2x")
    }), (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(Image/* default */.Z, {
      src: (DiscoverAndActivate_2x_default()),
      alt: "Discover and activate image",
      width: "505",
      height: "540",
      loading: "lazy"
    })]
  });
};

/* harmony default export */ var DiscoverAndActivate_DiscoverAndActivateImage = (DiscoverAndActivateImage);
;// CONCATENATED MODULE: ./src/views/CustomerAIPredictions/components/DiscoverAndActivate/DiscoverAndActivate.tsx


function DiscoverAndActivate_EMOTION_STRINGIFIED_CSS_ERROR_() { return "You have tried to stringify object returned from `css` function. It isn't supposed to be used directly (e.g. as value of the `className` prop), but rather handed to emotion so it can handle it (e.g. as value of `css` prop)."; }








var DiscoverAndActivate_copy = {
  heading: "Discover and activate the best audiences for every campaign",
  description: "CustomerAI Predictions includes pre-built Predictive Audiences to inspire new campaign ideas and help you quickly create AI-powered audiences in just a few clicks.",
  list: [{
    title: "Ready to buy audiences",
    description: "Includes customers who are most likely to purchase."
  }, {
    title: "Long shots audiences",
    description: "Includes customers who have previously interacted with your brand but aren't currently engaged."
  }, {
    title: "High LTV audiences",
    description: "Includes customers with high predictive lifetime value."
  }, {
    title: "Potential VIPs audiences",
    description: "Includes recently active customers with high predictive lifetime value as well as a high likelihood to purchase."
  }, {
    title: "Dormant audiences",
    description: "Includes inactive customers who are unlikely to purchase."
  }]
};

var DiscoverAndActivate_DiscoverAndActivate = function DiscoverAndActivate() {
  return (0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)(emotion_react_jsx_runtime_browser_esm/* Fragment */.HY, {
    children: [(0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(Section/* default */.ZP, {
      variant: "noCopy",
      children: (0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)(DiscoverAndActivate_StyledCopyTextBase, {
        centered: true,
        children: [(0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(CopyText/* Heading */.X6, {
          tag: "h2",
          children: DiscoverAndActivate_copy.heading
        }), (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(CopyText/* Description */.dk, {
          tag: "p",
          variant: "pLarge",
          children: DiscoverAndActivate_copy.description
        })]
      })
    }), (0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)(StyledSectionBase, {
      variant: "2Col",
      reverse: true,
      children: [(0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(Section/* Copy */.CK, {
        children: (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(ColumnTrack/* default */.Z, {
          children: DiscoverAndActivate_copy.list.map(function (_ref, key) {
            var title = _ref.title,
                description = _ref.description;
            return (0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)(CopyText/* default */.ZP, {
              children: [(0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(CopyText/* Heading */.X6, {
                tag: "h3",
                variant: "h5",
                children: title
              }), (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(CopyText/* Description */.dk, {
                tag: "p",
                children: description
              })]
            }, key);
          })
        })
      }), (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(Section/* Contents */.AU, {
        children: (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(DiscoverAndActivate_DiscoverAndActivateImage, {})
      })]
    })]
  });
};

var DiscoverAndActivate_StyledCopyTextBase = /*#__PURE__*/(0,emotion_styled_base_browser_esm/* default */.Z)(CopyText/* default */.ZP,  true ? {
  target: "e1jiwr3j1"
} : 0)( true ? {
  name: "z9xs2w",
  styles: "max-width:844px;margin:0 auto"
} : 0);

var StyledSectionBase = /*#__PURE__*/(0,emotion_styled_base_browser_esm/* default */.Z)(Section/* default */.ZP,  true ? {
  target: "e1jiwr3j0"
} : 0)(Section/* Wrapper */.im, "{padding-top:0;}" + ( true ? "" : 0));

/* harmony default export */ var components_DiscoverAndActivate_DiscoverAndActivate = (DiscoverAndActivate_DiscoverAndActivate);
// EXTERNAL MODULE: ./src/views/CustomerAIPredictions/assets/OgImage.jpg
var OgImage = __webpack_require__(31305);
var OgImage_default = /*#__PURE__*/__webpack_require__.n(OgImage);
;// CONCATENATED MODULE: ./src/views/CustomerAIPredictions/CustomerAIPredictions.tsx

















var CustomerAIPredictions_copy = {
  pageTitle: "CustomerAI Predictions | Twilio Segment",
  pageDescription: "With CustomerAI Predictions, marketers can easily predict future customer behavior to deliver precisely personalized campaigns without needing to tap data science teams."
};

var CustomerAIPredictionsView = function CustomerAIPredictionsView() {
  return (0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)(AppearanceContext/* AppearanceProvider */.x, {
    appearance: "twilioLight",
    children: [(0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)(layout/* default */.Z, {
      pageTitle: CustomerAIPredictions_copy.pageTitle,
      pageDescription: CustomerAIPredictions_copy.pageDescription,
      pageOG: (OgImage_default()),
      children: [(0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(Navigation/* default */.Z, {}), (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(components_Hero_Hero, {}), (0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)("main", {
        children: [(0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(components_PredictiveAudiences_PredictiveAudiences, {}), (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(DividerSection/* default */.Z, {}), (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(components_PredictiveAIModels_PredictiveAIModels, {}), (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(DividerSection/* default */.Z, {}), (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(components_DiscoverAndActivate_DiscoverAndActivate, {}), (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(DividerSection/* default */.Z, {}), (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(BoostCampaign_BoostCampaign, {}), (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(DividerSection/* default */.Z, {}), (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(TrustIn_TrustIn, {}), (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(SingleTestimonial_SingleTestimonial, {}), (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(DividerSection/* default */.Z, {}), (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(Resources_Resources, {}), (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(GettingStarted["default"], {})]
      })]
    }), (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(Footer/* default */.Z, {})]
  });
};

/* harmony default export */ var CustomerAIPredictions_CustomerAIPredictions = (CustomerAIPredictionsView);
;// CONCATENATED MODULE: ./src/pages/solutions/ai/customerai-predictions/index.tsx



var CustomerAIPredictions = function CustomerAIPredictions() {
  return (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(CustomerAIPredictions_CustomerAIPredictions, {});
};

/* harmony default export */ var customerai_predictions = (CustomerAIPredictions);

/***/ }),

/***/ 96856:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "Z": function() { return /* reexport */ useLocation_useLocation; }
});

// EXTERNAL MODULE: ../../node_modules/next/dist/compiled/@babel/runtime/helpers/esm/asyncToGenerator.js
var asyncToGenerator = __webpack_require__(20406);
// EXTERNAL MODULE: ../../node_modules/next/dist/compiled/@babel/runtime/regenerator/index.js
var regenerator = __webpack_require__(28526);
var regenerator_default = /*#__PURE__*/__webpack_require__.n(regenerator);
// EXTERNAL MODULE: ../../node_modules/react/index.js
var react = __webpack_require__(2784);
// EXTERNAL MODULE: ../../libs/api/staticSiteBackend/client.ts + 2 modules
var client = __webpack_require__(39896);
;// CONCATENATED MODULE: ../../libs/api/staticSiteBackend/location.ts



var fetchLocation = function fetchLocation(client, signal) {
  return client.get("/location/", {
    signal: signal,
    headers: [["X-Backend-Api", String("KiBZKjNMR0k4ZX1pcGZjIG9fRnh3V14m")]]
  });
};

var fetchLocationCode = /*#__PURE__*/function () {
  var _ref = (0,asyncToGenerator/* default */.Z)( /*#__PURE__*/regenerator_default().mark(function _callee(client, signal) {
    var code;
    return regenerator_default().wrap(function _callee$(_context) {
      while (1) {
        switch (_context.prev = _context.next) {
          case 0:
            _context.next = 2;
            return client.get("/location/countryCode/", {
              signal: signal,
              headers: [["X-Backend-Api", String("KiBZKjNMR0k4ZX1pcGZjIG9fRnh3V14m")]]
            });

          case 2:
            code = _context.sent;
            return _context.abrupt("return", code.data);

          case 4:
          case "end":
            return _context.stop();
        }
      }
    }, _callee);
  }));

  return function fetchLocationCode(_x, _x2) {
    return _ref.apply(this, arguments);
  };
}();


;// CONCATENATED MODULE: ../../libs/api/utils/useLocation/useLocation.ts





/**
 * A hook that provides the country code of the user's location.
 * @returns The country code of the user's location.
 */

var useLocation = function useLocation() {
  var _useState = (0,react.useState)(""),
      code = _useState[0],
      setCode = _useState[1];

  var fetchData = (0,react.useCallback)( /*#__PURE__*/function () {
    var _ref = (0,asyncToGenerator/* default */.Z)( /*#__PURE__*/regenerator_default().mark(function _callee(signal) {
      var response;
      return regenerator_default().wrap(function _callee$(_context) {
        while (1) {
          switch (_context.prev = _context.next) {
            case 0:
              _context.prev = 0;
              _context.next = 3;
              return fetchLocationCode((0,client/* createClient */.e)(), signal);

            case 3:
              response = _context.sent;
              setCode(response.toLowerCase());
              _context.next = 10;
              break;

            case 7:
              _context.prev = 7;
              _context.t0 = _context["catch"](0);
              setCode("us");

            case 10:
            case "end":
              return _context.stop();
          }
        }
      }, _callee, null, [[0, 7]]);
    }));

    return function (_x) {
      return _ref.apply(this, arguments);
    };
  }(), []);
  (0,react.useEffect)(function () {
    var controller = new AbortController();
    fetchData(controller.signal);
    return function () {
      controller.abort();
    };
  }, [fetchData]);
  return code;
};

/* harmony default export */ var useLocation_useLocation = (useLocation);
;// CONCATENATED MODULE: ../../libs/api/utils/useLocation/index.ts


/***/ }),

/***/ 805:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "Y": function() { return /* binding */ DemoProvider; },
/* harmony export */   "d": function() { return /* binding */ DemoContext; }
/* harmony export */ });
/* harmony import */ var _workdir_node_modules_next_dist_compiled_babel_runtime_helpers_esm_defineProperty_js__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(95235);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(2784);
/* harmony import */ var _emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(52903);


function ownKeys(object, enumerableOnly) {
  var keys = Object.keys(object);

  if (Object.getOwnPropertySymbols) {
    var symbols = Object.getOwnPropertySymbols(object);
    enumerableOnly && (symbols = symbols.filter(function (sym) {
      return Object.getOwnPropertyDescriptor(object, sym).enumerable;
    })), keys.push.apply(keys, symbols);
  }

  return keys;
}

function _objectSpread(target) {
  for (var i = 1; i < arguments.length; i++) {
    var source = null != arguments[i] ? arguments[i] : {};
    i % 2 ? ownKeys(Object(source), !0).forEach(function (key) {
      (0,_workdir_node_modules_next_dist_compiled_babel_runtime_helpers_esm_defineProperty_js__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)(target, key, source[key]);
    }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) {
      Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
    });
  }

  return target;
}



var DemoContext = /*#__PURE__*/(0,react__WEBPACK_IMPORTED_MODULE_1__.createContext)({
  completedFormData: undefined,
  // eslint-disable-next-line @typescript-eslint/no-empty-function
  setCompletedFormData: function setCompletedFormData() {}
});
var DemoProvider = function DemoProvider(_ref) {
  var children = _ref.children;

  var _useState = (0,react__WEBPACK_IMPORTED_MODULE_1__.useState)({
    completedFormData: undefined,
    setCompletedFormData: function setCompletedFormData(value) {
      return setState(function (prevState) {
        return _objectSpread(_objectSpread({}, prevState), {}, {
          completedFormData: value
        });
      });
    }
  }),
      state = _useState[0],
      setState = _useState[1];

  return (0,_emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_2__/* .jsx */ .tZ)(DemoContext.Provider, {
    value: state,
    children: children
  });
};

/***/ }),

/***/ 33514:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "Dx": function() { return /* reexport safe */ _FeatureBox__WEBPACK_IMPORTED_MODULE_0__.Dx; },
/* harmony export */   "Hq": function() { return /* reexport safe */ _FeatureBox__WEBPACK_IMPORTED_MODULE_0__.Hq; },
/* harmony export */   "ZP": function() { return /* reexport safe */ _FeatureBox__WEBPACK_IMPORTED_MODULE_0__.Ob; },
/* harmony export */   "h4": function() { return /* reexport safe */ _FeatureBox__WEBPACK_IMPORTED_MODULE_0__.h4; },
/* harmony export */   "uT": function() { return /* reexport safe */ _FeatureBox__WEBPACK_IMPORTED_MODULE_0__.uT; },
/* harmony export */   "xv": function() { return /* reexport safe */ _FeatureBox__WEBPACK_IMPORTED_MODULE_0__.xv; }
/* harmony export */ });
/* harmony import */ var _FeatureBox__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(13379);

_FeatureBox__WEBPACK_IMPORTED_MODULE_0__/* .FeatureBox.displayName */ .Ob.displayName = "FeatureBoxBase";
_FeatureBox__WEBPACK_IMPORTED_MODULE_0__/* .Body.displayName */ .uT.displayName = "FeatureBox.Body";
_FeatureBox__WEBPACK_IMPORTED_MODULE_0__/* .Header.displayName */ .h4.displayName = "FeatureBox.Header";
_FeatureBox__WEBPACK_IMPORTED_MODULE_0__/* .Text.displayName */ .xv.displayName = "FeatureBox.Text";
_FeatureBox__WEBPACK_IMPORTED_MODULE_0__/* .Title.displayName */ .Dx.displayName = "FeatureBox.Title";


/***/ }),

/***/ 79600:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "Z": function() { return /* reexport */ components_IconWrapper_IconWrapper; }
});

// EXTERNAL MODULE: ../../node_modules/next/dist/compiled/@babel/runtime/helpers/esm/defineProperty.js
var defineProperty = __webpack_require__(95235);
// EXTERNAL MODULE: ../../node_modules/next/dist/compiled/@babel/runtime/helpers/esm/objectWithoutProperties.js + 1 modules
var objectWithoutProperties = __webpack_require__(82269);
// EXTERNAL MODULE: ../../node_modules/react/index.js
var react = __webpack_require__(2784);
// EXTERNAL MODULE: ../../libs/matcha/useDesignTokens/index.ts
var useDesignTokens = __webpack_require__(98439);
// EXTERNAL MODULE: ../../node_modules/@emotion/styled/base/dist/emotion-styled-base.browser.esm.js
var emotion_styled_base_browser_esm = __webpack_require__(92952);
// EXTERNAL MODULE: ../../node_modules/@emotion/react/dist/emotion-react.browser.esm.js
var emotion_react_browser_esm = __webpack_require__(28165);
;// CONCATENATED MODULE: ../../libs/matcha/components/IconWrapper/IconWrapper.views.tsx


function _EMOTION_STRINGIFIED_CSS_ERROR__() {
  return "You have tried to stringify object returned from `css` function. It isn't supposed to be used directly (e.g. as value of the `className` prop), but rather handed to emotion so it can handle it (e.g. as value of `css` prop).";
}


var IconWrapper = /*#__PURE__*/(0,emotion_styled_base_browser_esm/* default */.Z)("div",  true ? {
  target: "e1bo4d8j1"
} : 0)("width:44px;height:44px;border-radius:50%;color:", function (_ref2) {
  var color = _ref2.color;
  return color;
}, ";background-color:", function (_ref3) {
  var backgroundColor = _ref3.backgroundColor;
  return backgroundColor;
}, ";", function (_ref4) {
  var elevation = _ref4.elevation,
      theme = _ref4.theme;
  return elevation &&
  /*#__PURE__*/

  /*#__PURE__*/
  (0,emotion_react_browser_esm/* css */.iv)("box-shadow:", theme.shadows[elevation], ";" + ( true ? "" : 0),  true ? "" : 0,  true ? "" : 0,  true ? "" : 0);
}, ";" + ( true ? "" : 0));

var _ref =  true ? {
  name: "1iixa1j",
  styles: "width:40px;height:40px;svg{width:40px;height:40px;}padding:2px"
} : 0;

var Icon = /*#__PURE__*/(0,emotion_styled_base_browser_esm/* default */.Z)("span",  true ? {
  target: "e1bo4d8j0"
} : 0)("display:block;width:24px;height:24px;padding:10px;", function (_ref5) {
  var variant = _ref5.variant;
  return variant === "transparent" && _ref;
}, ";" + ( true ? "" : 0));
// EXTERNAL MODULE: ../../node_modules/@emotion/react/jsx-runtime/dist/emotion-react-jsx-runtime.browser.esm.js
var emotion_react_jsx_runtime_browser_esm = __webpack_require__(52903);
;// CONCATENATED MODULE: ../../libs/matcha/components/IconWrapper/IconWrapper.tsx


var _excluded = ["tokens", "variant", "elevation", "className", "tag", "children"];

function ownKeys(object, enumerableOnly) {
  var keys = Object.keys(object);

  if (Object.getOwnPropertySymbols) {
    var symbols = Object.getOwnPropertySymbols(object);
    enumerableOnly && (symbols = symbols.filter(function (sym) {
      return Object.getOwnPropertyDescriptor(object, sym).enumerable;
    })), keys.push.apply(keys, symbols);
  }

  return keys;
}

function _objectSpread(target) {
  for (var i = 1; i < arguments.length; i++) {
    var source = null != arguments[i] ? arguments[i] : {};
    i % 2 ? ownKeys(Object(source), !0).forEach(function (key) {
      (0,defineProperty/* default */.Z)(target, key, source[key]);
    }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) {
      Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
    });
  }

  return target;
}





var BaseIconWrapper = /*#__PURE__*/(0,react.forwardRef)(function (_ref, ref) {
  var tokens = _ref.tokens,
      variant = _ref.variant,
      elevation = _ref.elevation,
      className = _ref.className,
      tag = _ref.tag,
      children = _ref.children,
      rest = (0,objectWithoutProperties/* default */.Z)(_ref, _excluded);

  return (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(IconWrapper, _objectSpread(_objectSpread(_objectSpread({
    ref: ref,
    className: className,
    elevation: elevation,
    as: tag
  }, tokens), rest), {}, {
    children: (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(Icon, {
      variant: variant,
      children: children
    })
  }));
});

var getBackgroundPropTokens = function getBackgroundPropTokens(background, theme) {
  switch (background) {
    case "white":
      return {
        backgroundColor: theme.palette.neutrals.white[100],
        color: theme.palette.brand.boysenberry[500]
      };

    case "light":
      return {
        backgroundColor: theme.palette.brand.boysenberry[100],
        color: theme.palette.brand.darkAcai[700]
      };

    case "dark":
      return {
        backgroundColor: theme.palette.brand.darkAcai[600],
        color: theme.palette.brand.boysenberry[200]
      };

    default:
      return {
        backgroundColor: theme.palette.neutrals.white[100],
        color: theme.palette.twilio.gray[100]
      };
  }
};

var IconWrapper_IconWrapper = (0,useDesignTokens/* withDesignTokens */.Y)(BaseIconWrapper, function (_ref2) {
  var elevation = _ref2.elevation;
  return {
    elevation: elevation
  };
}, {
  light: function light(theme, props) {
    if (props.variant === "transparent") {
      return {
        color: theme.palette.brand.darkAcai[700],
        backgroundColor: "transparent"
      };
    }

    if (props.background) {
      return getBackgroundPropTokens(props.background, theme);
    }

    return {
      color: theme.palette.brand.darkAcai[700],
      backgroundColor: theme.palette.brand.boysenberry[100]
    };
  },
  dark: function dark(theme, props) {
    if (props.variant === "transparent") {
      return {
        color: theme.palette.neutrals.white[100],
        backgroundColor: "transparent"
      };
    }

    if (props.background) {
      return getBackgroundPropTokens(props.background, theme);
    }

    return {
      color: theme.palette.brand.boysenberry[200],
      backgroundColor: theme.palette.brand.darkAcai[600]
    };
  },
  twilioLight: function twilioLight(theme, props) {
    if (props.variant === "transparent") {
      return {
        color: theme.palette.twilio.gray[100],
        backgroundColor: "transparent"
      };
    }

    if (props.background) {
      return getBackgroundPropTokens(props.background, theme);
    }

    return {
      color: theme.palette.twilio.gray[100],
      backgroundColor: theme.palette.neutrals.white[100]
    };
  }
});
/* harmony default export */ var components_IconWrapper_IconWrapper = (IconWrapper_IconWrapper);
;// CONCATENATED MODULE: ../../libs/matcha/components/IconWrapper/index.ts


/***/ }),

/***/ 31714:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "MI": function() { return /* binding */ SignupButton; },
/* harmony export */   "_f": function() { return /* binding */ SignupButtonText; }
/* harmony export */ });
/* harmony import */ var _workdir_node_modules_next_dist_compiled_babel_runtime_helpers_esm_defineProperty_js__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(95235);
/* harmony import */ var _workdir_node_modules_next_dist_compiled_babel_runtime_helpers_esm_objectWithoutProperties_js__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(82269);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(2784);
/* harmony import */ var _segment_matcha_components_Button__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(33445);
/* harmony import */ var _segment_matcha_components_ButtonText__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(74870);
/* harmony import */ var _segment_contexts_page__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(17782);
/* harmony import */ var _emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(52903);


var _excluded = ["color", "variant", "size", "expanded", "children", "additionalParams", "linkToApp"],
    _excluded2 = ["appearance", "children", "additionalParams", "linkToApp"];

function ownKeys(object, enumerableOnly) {
  var keys = Object.keys(object);

  if (Object.getOwnPropertySymbols) {
    var symbols = Object.getOwnPropertySymbols(object);
    enumerableOnly && (symbols = symbols.filter(function (sym) {
      return Object.getOwnPropertyDescriptor(object, sym).enumerable;
    })), keys.push.apply(keys, symbols);
  }

  return keys;
}

function _objectSpread(target) {
  for (var i = 1; i < arguments.length; i++) {
    var source = null != arguments[i] ? arguments[i] : {};
    i % 2 ? ownKeys(Object(source), !0).forEach(function (key) {
      (0,_workdir_node_modules_next_dist_compiled_babel_runtime_helpers_esm_defineProperty_js__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)(target, key, source[key]);
    }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) {
      Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
    });
  }

  return target;
}







var useTransformUrl = function useTransformUrl(customQuery, linkToApp) {
  var _usePageConfig = (0,_segment_contexts_page__WEBPACK_IMPORTED_MODULE_4__/* .usePageConfig */ .Gm)(),
      queryParamsFromCookie = _usePageConfig.queryParamsFromCookie,
      appUrl = _usePageConfig.appUrl;

  var hostUrl = linkToApp ? appUrl : "https://segment.com";
  var queryString = (0,react__WEBPACK_IMPORTED_MODULE_1__.useMemo)(function () {
    var query = new URLSearchParams(queryParamsFromCookie);

    for (var qs in customQuery) {
      query.append(qs, customQuery[qs]);
    }

    return query.toString() ? "?".concat(query.toString()) : "";
  }, [queryParamsFromCookie, customQuery]);
  return "".concat(hostUrl, "/signup/").concat(queryString);
};

var SignupButton = /*#__PURE__*/(0,react__WEBPACK_IMPORTED_MODULE_1__.forwardRef)(function (_ref, ref) {
  var _ref$color = _ref.color,
      color = _ref$color === void 0 ? "primary" : _ref$color,
      _ref$variant = _ref.variant,
      variant = _ref$variant === void 0 ? "filled" : _ref$variant,
      _ref$size = _ref.size,
      size = _ref$size === void 0 ? "large" : _ref$size,
      expanded = _ref.expanded,
      children = _ref.children,
      additionalParams = _ref.additionalParams,
      _ref$linkToApp = _ref.linkToApp,
      linkToApp = _ref$linkToApp === void 0 ? false : _ref$linkToApp,
      rest = (0,_workdir_node_modules_next_dist_compiled_babel_runtime_helpers_esm_objectWithoutProperties_js__WEBPACK_IMPORTED_MODULE_5__/* ["default"] */ .Z)(_ref, _excluded);

  var url = useTransformUrl(additionalParams, linkToApp);
  return (0,_emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_6__/* .jsx */ .tZ)(_segment_matcha_components_Button__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z, _objectSpread(_objectSpread({
    variant: variant,
    size: size,
    color: color,
    expanded: expanded,
    tag: "a",
    href: url,
    ref: ref
  }, rest), {}, {
    children: children
  }));
});
var SignupButtonText = /*#__PURE__*/(0,react__WEBPACK_IMPORTED_MODULE_1__.forwardRef)(function (_ref2, ref) {
  var externalAppearance = _ref2.appearance,
      children = _ref2.children,
      additionalParams = _ref2.additionalParams,
      _ref2$linkToApp = _ref2.linkToApp,
      linkToApp = _ref2$linkToApp === void 0 ? false : _ref2$linkToApp,
      rest = (0,_workdir_node_modules_next_dist_compiled_babel_runtime_helpers_esm_objectWithoutProperties_js__WEBPACK_IMPORTED_MODULE_5__/* ["default"] */ .Z)(_ref2, _excluded2);

  var url = useTransformUrl(additionalParams, linkToApp);
  return (0,_emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_6__/* .jsx */ .tZ)(_segment_matcha_components_ButtonText__WEBPACK_IMPORTED_MODULE_3__/* ["default"] */ .Z, _objectSpread(_objectSpread({
    ref: ref,
    href: url,
    appearance: externalAppearance
  }, rest), {}, {
    children: children
  }));
});
/* unused harmony default export */ var __WEBPACK_DEFAULT_EXPORT__ = ((/* unused pure expression or super */ null && (SignupButton)));

/***/ }),

/***/ 77931:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "Z": function() { return /* reexport safe */ _SignupButton__WEBPACK_IMPORTED_MODULE_0__.MI; },
/* harmony export */   "_": function() { return /* reexport safe */ _SignupButton__WEBPACK_IMPORTED_MODULE_0__._f; }
/* harmony export */ });
/* harmony import */ var _SignupButton__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(31714);


/***/ }),

/***/ 52876:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "Z": function() { return /* binding */ DividerSection_DividerSection; }
});

// EXTERNAL MODULE: ../../libs/matcha/components/Divider/index.ts + 1 modules
var Divider = __webpack_require__(76305);
// EXTERNAL MODULE: ../../libs/matcha/recipes/Section/index.ts + 2 modules
var Section = __webpack_require__(88392);
// EXTERNAL MODULE: ../../node_modules/@emotion/styled/base/dist/emotion-styled-base.browser.esm.js
var emotion_styled_base_browser_esm = __webpack_require__(92952);
;// CONCATENATED MODULE: ../../libs/templates/DividerSection/DividerSection.views.tsx


var StyledSectionBase = /*#__PURE__*/(0,emotion_styled_base_browser_esm/* default */.Z)(Section/* default */.ZP,  true ? {
  target: "ec103ko0"
} : 0)(Section/* Wrapper */.im, "{padding-top:0;padding-bottom:0;}" + ( true ? "" : 0));
// EXTERNAL MODULE: ../../node_modules/@emotion/react/jsx-runtime/dist/emotion-react-jsx-runtime.browser.esm.js
var emotion_react_jsx_runtime_browser_esm = __webpack_require__(52903);
;// CONCATENATED MODULE: ../../libs/templates/DividerSection/DividerSection.tsx





var DividerSection = function DividerSection() {
  return (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(StyledSectionBase, {
    variant: "noCopy",
    children: (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(Section/* Contents */.AU, {
      children: (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(Divider/* default */.Z, {})
    })
  });
};

/* harmony default export */ var DividerSection_DividerSection = (DividerSection);

/***/ }),

/***/ 85507:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "Z": function() { return /* reexport safe */ _DividerSection__WEBPACK_IMPORTED_MODULE_0__.Z; }
/* harmony export */ });
/* harmony import */ var _DividerSection__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(52876);


/***/ }),

/***/ 34810:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "Z": function() { return /* binding */ Footer_Footer; }
});

// EXTERNAL MODULE: ../../node_modules/next/dist/compiled/@babel/runtime/helpers/esm/defineProperty.js
var defineProperty = __webpack_require__(95235);
// EXTERNAL MODULE: ../../node_modules/next/dist/compiled/@babel/runtime/helpers/esm/objectWithoutProperties.js + 1 modules
var objectWithoutProperties = __webpack_require__(82269);
// EXTERNAL MODULE: ../../node_modules/next/link.js
var next_link = __webpack_require__(39097);
var link_default = /*#__PURE__*/__webpack_require__.n(next_link);
// EXTERNAL MODULE: ../../libs/matcha/foundations/AppearanceContext/index.ts + 1 modules
var AppearanceContext = __webpack_require__(9381);
// EXTERNAL MODULE: ../../libs/matcha/components/Button/index.ts
var Button = __webpack_require__(33445);
// EXTERNAL MODULE: ../../libs/matcha/components/SegmentLogo/index.ts + 2 modules
var SegmentLogo = __webpack_require__(84672);
// EXTERNAL MODULE: ../../libs/matcha/recipes/Footer/index.ts + 4 modules
var recipes_Footer = __webpack_require__(80653);
// EXTERNAL MODULE: ../../libs/utils/getAbsoluteUrl/getAbsoluteUrl.ts
var getAbsoluteUrl = __webpack_require__(43848);
// EXTERNAL MODULE: ../../libs/contexts/page.ts
var page = __webpack_require__(17782);
// EXTERNAL MODULE: ../../libs/templates/Footer/data.ts
var Footer_data = __webpack_require__(52661);
// EXTERNAL MODULE: ../../node_modules/@emotion/styled/base/dist/emotion-styled-base.browser.esm.js
var emotion_styled_base_browser_esm = __webpack_require__(92952);
;// CONCATENATED MODULE: ../../libs/templates/Footer/Footer.views.tsx


function _EMOTION_STRINGIFIED_CSS_ERROR__() {
  return "You have tried to stringify object returned from `css` function. It isn't supposed to be used directly (e.g. as value of the `className` prop), but rather handed to emotion so it can handle it (e.g. as value of `css` prop).";
}

var BrandLink = /*#__PURE__*/(0,emotion_styled_base_browser_esm/* default */.Z)("span",  true ? {
  target: "ed41syo0"
} : 0)( true ? {
  name: "vetbs0",
  styles: "display:grid"
} : 0);
// EXTERNAL MODULE: ../../node_modules/@emotion/react/jsx-runtime/dist/emotion-react-jsx-runtime.browser.esm.js
var emotion_react_jsx_runtime_browser_esm = __webpack_require__(52903);
;// CONCATENATED MODULE: ../../libs/templates/Footer/Footer.tsx


var _excluded = ["appearance"];

function ownKeys(object, enumerableOnly) {
  var keys = Object.keys(object);

  if (Object.getOwnPropertySymbols) {
    var symbols = Object.getOwnPropertySymbols(object);
    enumerableOnly && (symbols = symbols.filter(function (sym) {
      return Object.getOwnPropertyDescriptor(object, sym).enumerable;
    })), keys.push.apply(keys, symbols);
  }

  return keys;
}

function _objectSpread(target) {
  for (var i = 1; i < arguments.length; i++) {
    var source = null != arguments[i] ? arguments[i] : {};
    i % 2 ? ownKeys(Object(source), !0).forEach(function (key) {
      (0,defineProperty/* default */.Z)(target, key, source[key]);
    }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) {
      Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
    });
  }

  return target;
}












var Footer = function Footer(_ref) {
  var appearance = _ref.appearance,
      props = (0,objectWithoutProperties/* default */.Z)(_ref, _excluded);

  var pageConfig = (0,page/* usePageConfig */.Gm)();
  var footerAppearance = (0,AppearanceContext/* useAppearance */.M)(appearance);
  var ctaText = "See how it works";
  var data = (0,Footer_data/* default */.Z)(pageConfig);
  return (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(recipes_Footer/* default */.Z, _objectSpread({
    bottomLinks: data.bottomLinks,
    mainLinks: data.mainLinks,
    copyright: data.copyright,
    logo: (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(AppearanceContext/* AppearanceProvider */.x, {
      appearance: footerAppearance,
      children: (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)((link_default()), {
        href: (0,getAbsoluteUrl/* default */.Z)("/", pageConfig),
        passHref: true,
        children: (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(BrandLink, {
          children: (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(SegmentLogo/* default */.Z, {
            alt: "Twilio, Inc.",
            footer: true
          })
        })
      })
    }),
    cta: (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(Button/* default */.Z, {
      color: "primary",
      variant: "filled",
      size: "large",
      href: (0,getAbsoluteUrl/* default */.Z)("/demo/", pageConfig),
      children: ctaText
    }),
    appearance: appearance
  }, props));
};

/* harmony default export */ var Footer_Footer = (Footer);

/***/ }),

/***/ 52661:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var _segment_utils_getAbsoluteUrl__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(43848);


var getData = function getData(pageConfig) {
  return {
    logo: {
      src: "/images/SegmentLogoWhite.png",
      srcSet: "/images/SegmentLogoWhite@2x.png 2x",
      alt: "Twilio, Inc.",
      width: 300,
      height: 65
    },
    bottomLinks: [{
      url: "https://www.twilio.com/legal/privacy/",
      title: "Privacy policy"
    }, {
      url: "https://www.twilio.com/legal/tos/",
      title: "Terms of Service"
    }],
    mainLinks: [{
      title: "Products",
      links: [{
        url: (0,_segment_utils_getAbsoluteUrl__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)("/product/connections/", pageConfig),
        title: "Connections"
      }, {
        url: (0,_segment_utils_getAbsoluteUrl__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)("/product/protocols/", pageConfig),
        title: "Protocols"
      }, {
        url: (0,_segment_utils_getAbsoluteUrl__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)("/product/unify/", pageConfig),
        title: "Unify"
      }, {
        url: (0,_segment_utils_getAbsoluteUrl__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)("/product/twilio-engage/", pageConfig),
        title: "Twilio Engage"
      }, {
        url: (0,_segment_utils_getAbsoluteUrl__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)("/customer-data-platform/", pageConfig),
        title: "Customer Data Platform",
        rel: "nofollow"
      }, {
        url: (0,_segment_utils_getAbsoluteUrl__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)("/catalog/", pageConfig),
        title: "Integrations Catalog"
      }, {
        url: (0,_segment_utils_getAbsoluteUrl__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)("/pricing/", pageConfig),
        title: "Pricing"
      }, {
        url: (0,_segment_utils_getAbsoluteUrl__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)("/security/", pageConfig),
        title: "Security"
      }, {
        url: (0,_segment_utils_getAbsoluteUrl__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)("/product/gdpr/", pageConfig),
        title: "GDPR"
      }]
    }, {
      title: "For Developers",
      links: [{
        url: "https://segment.com/docs/",
        title: "Documentation"
      }, {
        url: "https://docs.segmentapis.com/",
        title: "Segment API"
      }, {
        url: (0,_segment_utils_getAbsoluteUrl__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)("/partners/developer-portal/", pageConfig),
        title: "Build on Segment"
      }, {
        url: (0,_segment_utils_getAbsoluteUrl__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)("/opensource/", pageConfig),
        title: "Open Source"
      }, {
        url: (0,_segment_utils_getAbsoluteUrl__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)("/engineering/", pageConfig),
        title: "Engineering Team"
      }]
    }, {
      title: "Company",
      links: [{
        url: "https://www.twilio.com/company/jobs/",
        title: "Careers"
      }, {
        url: (0,_segment_utils_getAbsoluteUrl__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)("https://segment.com/blog/", pageConfig),
        title: "Blog"
      }, {
        url: (0,_segment_utils_getAbsoluteUrl__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)("https://segment.com/newsroom/", pageConfig),
        title: "Press"
      }, {
        url: (0,_segment_utils_getAbsoluteUrl__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)("/events/", pageConfig),
        title: "Events"
      }, {
        url: (0,_segment_utils_getAbsoluteUrl__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)("/good-data-better-marketing/", pageConfig),
        title: "Podcast"
      }, {
        url: (0,_segment_utils_getAbsoluteUrl__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)("/growth-center/", pageConfig),
        title: "Growth Center"
      }, {
        url: (0,_segment_utils_getAbsoluteUrl__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)("/data-hub/", pageConfig),
        title: "Data Hub"
      }]
    }, {
      title: "Support",
      links: [{
        url: (0,_segment_utils_getAbsoluteUrl__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)("/help/", pageConfig),
        title: "Help Center"
      }, {
        url: (0,_segment_utils_getAbsoluteUrl__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)("/contact/", pageConfig),
        title: "Contact us"
      }, {
        url: (0,_segment_utils_getAbsoluteUrl__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)("/resources/", pageConfig),
        title: "Resources"
      }, {
        url: (0,_segment_utils_getAbsoluteUrl__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)("/recipes/", pageConfig),
        title: "Recipes"
      }, {
        url: (0,_segment_utils_getAbsoluteUrl__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)("/services/", pageConfig),
        title: "Professional Services"
      }, {
        url: "https://segment.com/security/bulletins/",
        title: "Security Bulletins"
      }, {
        url: "https://segment.com/docs/",
        title: "Documentation"
      }, {
        url: "https://segment.com/release-notes/",
        title: "Release Notes"
      }, {
        url: (0,_segment_utils_getAbsoluteUrl__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)("/partners/", pageConfig),
        title: "Become a Partner"
      }, {
        url: (0,_segment_utils_getAbsoluteUrl__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)("/resources/cdp/", pageConfig),
        title: "Guide to Customer Data Platforms"
      }]
    }],
    copyright: "\xA9 ".concat(new Date().getUTCFullYear(), " Twilio Inc. All Rights Reserved.")
  };
};

/* harmony default export */ __webpack_exports__["Z"] = (getData);

/***/ }),

/***/ 4009:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "Z": function() { return /* reexport safe */ _Footer__WEBPACK_IMPORTED_MODULE_0__.Z; }
/* harmony export */ });
/* harmony import */ var _Footer__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(34810);


/***/ }),

/***/ 77840:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "f": function() { return /* binding */ FormSubmitMessage; }
});

// UNUSED EXPORTS: default

// EXTERNAL MODULE: ../../node_modules/next/dist/compiled/@babel/runtime/helpers/esm/defineProperty.js
var defineProperty = __webpack_require__(95235);
// EXTERNAL MODULE: ../../node_modules/next/dist/compiled/@babel/runtime/helpers/esm/objectWithoutProperties.js + 1 modules
var objectWithoutProperties = __webpack_require__(82269);
// EXTERNAL MODULE: ../../libs/matcha/foundations/AppearanceContext/index.ts + 1 modules
var AppearanceContext = __webpack_require__(9381);
// EXTERNAL MODULE: ../../libs/matcha/useDesignTokens/index.ts
var useDesignTokens = __webpack_require__(98439);
;// CONCATENATED MODULE: ../../libs/templates/FormSubmitMessage/data.tsx
var data = {
  success: {
    demo: {
      description: "Thank you for submitting your request for a demo! Answer 4 more questions to help us pinpoint exactly what your team needs to get started with Segment."
    }
  },
  error: {
    demo: {
      description: "We are really sorry. There was an error processing your submission. Try reloading your browser, and submitting again."
    }
  }
};
// EXTERNAL MODULE: ../../node_modules/@emotion/styled/base/dist/emotion-styled-base.browser.esm.js
var emotion_styled_base_browser_esm = __webpack_require__(92952);
// EXTERNAL MODULE: ../../libs/matcha/components/Typography/index.ts
var Typography = __webpack_require__(89533);
;// CONCATENATED MODULE: ../../libs/templates/FormSubmitMessage/FormSubmitMessage.views.tsx


function _EMOTION_STRINGIFIED_CSS_ERROR__() {
  return "You have tried to stringify object returned from `css` function. It isn't supposed to be used directly (e.g. as value of the `className` prop), but rather handed to emotion so it can handle it (e.g. as value of `css` prop).";
}


var Wrapper = /*#__PURE__*/(0,emotion_styled_base_browser_esm/* default */.Z)("div",  true ? {
  target: "e10kq2lq3"
} : 0)("padding:32px;border:1px solid ", function (_ref) {
  var borderColor = _ref.borderColor;
  return borderColor;
}, ";border-radius:8px;text-align:left;" + ( true ? "" : 0));
var Header = /*#__PURE__*/(0,emotion_styled_base_browser_esm/* default */.Z)("div",  true ? {
  target: "e10kq2lq2"
} : 0)( true ? {
  name: "9qwgfz",
  styles: "display:grid;grid-auto-flow:column;grid-template-columns:max-content 1fr;align-items:center;gap:8px"
} : 0);
var StyledDescription = /*#__PURE__*/(0,emotion_styled_base_browser_esm/* default */.Z)(Typography/* default */.Z,  true ? {
  target: "e10kq2lq1"
} : 0)( true ? {
  name: "172op4w",
  styles: "margin-top:0;margin-bottom:0"
} : 0);
var StyledTypography = /*#__PURE__*/(0,emotion_styled_base_browser_esm/* default */.Z)(Typography/* default */.Z,  true ? {
  target: "e10kq2lq0"
} : 0)( true ? {
  name: "7ut0hf",
  styles: "margin:0;margin-bottom:16px"
} : 0);
// EXTERNAL MODULE: ../../node_modules/@emotion/react/jsx-runtime/dist/emotion-react-jsx-runtime.browser.esm.js
var emotion_react_jsx_runtime_browser_esm = __webpack_require__(52903);
;// CONCATENATED MODULE: ../../libs/templates/FormSubmitMessage/FormSubmitMessage.tsx


var _excluded = ["form", "status", "heading", "description", "tokens", "appearance"];

function ownKeys(object, enumerableOnly) {
  var keys = Object.keys(object);

  if (Object.getOwnPropertySymbols) {
    var symbols = Object.getOwnPropertySymbols(object);
    enumerableOnly && (symbols = symbols.filter(function (sym) {
      return Object.getOwnPropertyDescriptor(object, sym).enumerable;
    })), keys.push.apply(keys, symbols);
  }

  return keys;
}

function _objectSpread(target) {
  for (var i = 1; i < arguments.length; i++) {
    var source = null != arguments[i] ? arguments[i] : {};
    i % 2 ? ownKeys(Object(source), !0).forEach(function (key) {
      (0,defineProperty/* default */.Z)(target, key, source[key]);
    }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) {
      Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
    });
  }

  return target;
}








var BaseFormSubmitMessage = function BaseFormSubmitMessage(_ref) {
  var form = _ref.form,
      status = _ref.status,
      heading = _ref.heading,
      description = _ref.description,
      tokens = _ref.tokens,
      externalAppearance = _ref.appearance,
      rest = (0,objectWithoutProperties/* default */.Z)(_ref, _excluded);

  var appearance = (0,AppearanceContext/* useAppearance */.M)(externalAppearance);
  var localData = form && data[status][form];
  return (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(AppearanceContext/* AppearanceProvider */.x, {
    appearance: appearance,
    children: (0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)(Wrapper, _objectSpread(_objectSpread(_objectSpread({}, tokens.wrapper), rest), {}, {
      children: [heading && (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(Header, {
        children: (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(StyledTypography, {
          variant: "h4",
          tag: "p",
          tokens: tokens.header,
          children: heading
        })
      }), (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(StyledDescription, {
        variant: "pMedium",
        tokens: tokens.description,
        children: description || (localData === null || localData === void 0 ? void 0 : localData.description)
      })]
    }))
  });
};

var FormSubmitMessage = (0,useDesignTokens/* withDesignTokens */.Y)(BaseFormSubmitMessage, function () {
  return {};
}, {
  dark: function dark(theme) {
    return {
      wrapper: {
        borderColor: theme.palette.brand.darkAcai[300]
      },
      description: {
        color: theme.palette.brand.darkAcai[300]
      }
    };
  },
  light: function light(theme) {
    return {
      wrapper: {
        borderColor: theme.palette.brand.darkAcai[300]
      },
      description: {
        color: theme.palette.brand.darkAcai[500]
      }
    };
  },
  twilioLight: function twilioLight(theme) {
    return {
      wrapper: {
        borderColor: theme.palette.twilio.gray[30]
      },
      description: {
        color: theme.palette.twilio.gray[100]
      }
    };
  },
  twilioDark: function twilioDark(theme) {
    return {
      wrapper: {
        borderColor: theme.palette.twilio.gray[30]
      },
      description: {
        color: theme.palette.neutrals.white[100]
      }
    };
  }
});
/* harmony default export */ var FormSubmitMessage_FormSubmitMessage = ((/* unused pure expression or super */ null && (FormSubmitMessage)));

/***/ }),

/***/ 98960:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "Z": function() { return /* reexport */ DemoForm; }
});

// EXTERNAL MODULE: ../../node_modules/next/dist/compiled/@babel/runtime/helpers/esm/defineProperty.js
var defineProperty = __webpack_require__(95235);
// EXTERNAL MODULE: ../../node_modules/next/dist/compiled/@babel/runtime/helpers/esm/objectWithoutProperties.js + 1 modules
var objectWithoutProperties = __webpack_require__(82269);
// EXTERNAL MODULE: ../../node_modules/react/index.js
var react = __webpack_require__(2784);
// EXTERNAL MODULE: ../../node_modules/@emotion/react/dist/emotion-element-6a883da9.browser.esm.js + 1 modules
var emotion_element_6a883da9_browser_esm = __webpack_require__(28543);
// EXTERNAL MODULE: ../../node_modules/react-hook-form/dist/index.esm.mjs
var index_esm = __webpack_require__(63955);
// EXTERNAL MODULE: ../../node_modules/zod/lib/index.mjs
var lib = __webpack_require__(30195);
// EXTERNAL MODULE: ../../node_modules/@hookform/resolvers/zod/dist/zod.mjs + 1 modules
var zod = __webpack_require__(88883);
// EXTERNAL MODULE: ../../libs/matcha/foundations/AppearanceContext/index.ts + 1 modules
var AppearanceContext = __webpack_require__(9381);
// EXTERNAL MODULE: ../../libs/matcha/components/Button/index.ts
var Button = __webpack_require__(33445);
// EXTERNAL MODULE: ../../libs/templates/FormFields/index.ts + 22 modules
var FormFields = __webpack_require__(53790);
// EXTERNAL MODULE: ../../libs/templates/Disclaimer/index.ts + 3 modules
var Disclaimer = __webpack_require__(80401);
// EXTERNAL MODULE: ../../libs/templates/FormSubmitMessage/FormSubmitMessage.tsx + 2 modules
var FormSubmitMessage = __webpack_require__(77840);
// EXTERNAL MODULE: ../../libs/templates/FormSubmitAction/index.ts + 2 modules
var FormSubmitAction = __webpack_require__(17433);
// EXTERNAL MODULE: ../../libs/templates/TrackableForm/index.ts + 5 modules
var TrackableForm = __webpack_require__(53100);
// EXTERNAL MODULE: ../../libs/tracking/scripts/helpers.ts
var helpers = __webpack_require__(753);
// EXTERNAL MODULE: ../../libs/api/utils/useLocation/index.ts + 2 modules
var useLocation = __webpack_require__(96856);
// EXTERNAL MODULE: ../../libs/utils/useMatchMedia/index.ts + 1 modules
var useMatchMedia = __webpack_require__(61093);
// EXTERNAL MODULE: ../../libs/utils/useScrollToAnchor/index.ts
var useScrollToAnchor = __webpack_require__(68714);
// EXTERNAL MODULE: ../../libs/utils/regexes/sharedEmail.ts
var sharedEmail = __webpack_require__(13206);
// EXTERNAL MODULE: ../../libs/utils/regexes/email.ts
var email = __webpack_require__(36219);
// EXTERNAL MODULE: ../../libs/utils/regexes/form.ts
var regexes_form = __webpack_require__(63535);
// EXTERNAL MODULE: ../../libs/utils/regexes/lastName.ts
var lastName = __webpack_require__(51895);
;// CONCATENATED MODULE: ../../libs/utils/regexes/forbiddenEmail.ts
var customDomainList = ["@gmail.com", "@yahoo.com", "@hotmail.com", "@aol.com", "@hotmail.co.uk", "@hotmail.fr", "@msn.com", "@yahoo.fr", "@wanadoo.fr", "@orange.fr", "@comcast.net", "@yahoo.co.uk", "@yahoo.com.br", "@yahoo.co.in", "@live.com", "@rediffmail.com", "@free.fr", "@gmx.de", "@web.de", "@yandex.ru", "@ymail.com", "@libero.it", "@outlook.com", "@uol.com.br", "@bol.com.br", "@mail.ru", "@cox.net", "@hotmail.it", "@sbcglobal.net", "@sfr.fr", "@live.fr", "@verizon.net", "@live.co.uk", "@googlemail.com", "@yahoo.es", "@ig.com.br", "@live.nl", "@bigpond.com", "@terra.com.br", "@yahoo.it", "@neuf.fr", "@yahoo.de", "@alice.it", "@rocketmail.com", "@att.net", "@laposte.net", "@facebook.com", "@bellsouth.net", "@yahoo.in", "@hotmail.es", "@charter.net", "@yahoo.ca", "@yahoo.com.au", "@rambler.ru", "@hotmail.de", "@tiscali.it", "@shaw.ca", "@yahoo.co.jp", "@sky.com", "@earthlink.net", "@optonline.net", "@freenet.de", "@t-online.de", "@aliceadsl.fr", "@virgilio.it", "@home.nl", "@qq.com", "@telenet.be", "@me.com", "@yahoo.com.ar", "@tiscali.co.uk", "@yahoo.com.mx", "@voila.fr", "@gmx.net", "@mail.com", "@planet.nl", "@tin.it", "@live.it", "@ntlworld.com", "@arcor.de", "@yahoo.co.id", "@frontiernet.net", "@hetnet.nl", "@live.com.au", "@yahoo.com.sg", "@zonnet.nl", "@club-internet.fr", "@juno.com", "@optusnet.com.au", "@blueyonder.co.uk", "@bluewin.ch", "@skynet.be", "@sympatico.ca", "@windstream.net", "@mac.com", "@centurytel.net", "@chello.nl", "@live.ca", "@aim.com", "@bigpond.net.au", "@email.com", "@gmail", "@yahoo", "@hotmail", "@outlook", "@protonmail", "@gwk.com", "@free.", "@tutanota", "@gmx", "@mail2world", "@icloud", "@segment.com", "@.om", "@163.com", "@qq", "@gmai.com", "@yaoo.com", "@company.com", "@gail.com", "@abc.com", "@domain.com", "@gma.com", "@gnail.com", "@li.com", "@yah.com", "@5euros.com", "@business.com", "@emil.com", "@gaylord.info", "@gimal.com", "@gml.com", "@info.com", "@mailinator.com", "@w.com", "@yhoo.com", "@yo.com", "@0546876.com", "@10.com", "@101.gmail.com", "@11.com", "@12356gmail.com", "@123yahoo.com", "@175gmali.com", "@1servicesteamfrazier.com", "@2gmail.com", "@2ncad.com", "@365gmial.com", "@37.com", "@5024gmail.com", "@70gmail.com", "@72gmail.co.com", "@81gmail.com", "@8543g.mail.com", "@9085.gmail.com", "@9784.com", "@asdf.com", "@asdfas222334.com", "@asdsad.com", "@fuckyou.com", "@g.com", "@g.email", "@gamill.com", "@gimel.com", "@gl.com", "@gmaiil.com", "@gmaik.com", "@gmail-elif.com", "@gmail.com.pk", "@gmail.com120194", "@gmail.com4", "@gmaile.com", "@gmaill.com", "@gmaiol.com", "@gmaqil.com", "@gmaul.com", "@gmeel.come", "@gmil.comraj", "@gmsil.com", "@gmw.ere", "@gnail.con", "@haha.com", "@hahaha.com", "@il.co", "@il.com", "@test.cc", "@us.army.mil", "@ya.com", "@yaahoo.com", "@yahoo.coin", "@yho.com", "@yohoo.com", "@.aim", "@zoho", "@protonmail.com", "@mailinator", "@boutique1.com", "@bugfoo.com", "@duiter.com", "@fectode.com", "@gmial.com", "@jewelry.com", "@jims.net", "@jthoven.com", "@lolcorporate.com", "@naver.com", "@restaurant.com", "@stayclearbeauty.com", "@tem.com.my", "@thegymgroup.com", "@Marco.com"]; // Escape the dots in the domains, as they have a special meaning in regex

var escapedDomains = customDomainList.map(function (domain) {
  return domain.replace(/\./g, "\\.");
}); // Create the regex pattern using negative lookahead

var REGEX_PATTERN = "^(?!.*(".concat(escapedDomains.join("|"), ")).*$");
var forbiddenEmailRegex = new RegExp(REGEX_PATTERN, "i"); // Use the 'i' flag for case-insensitive matching

/* harmony default export */ var forbiddenEmail = (forbiddenEmailRegex);
// EXTERNAL MODULE: ../../libs/contexts/page.ts
var page = __webpack_require__(17782);
// EXTERNAL MODULE: ../../libs/templates/Forms/ProgressiveProfileForm/ProgressiveProfileForm.tsx + 2 modules
var ProgressiveProfileForm = __webpack_require__(6612);
// EXTERNAL MODULE: ../../node_modules/@emotion/styled/base/dist/emotion-styled-base.browser.esm.js
var emotion_styled_base_browser_esm = __webpack_require__(92952);
;// CONCATENATED MODULE: ../../libs/templates/Forms/DemoForm/DemoForm.views.tsx

var FormWrapper = /*#__PURE__*/(0,emotion_styled_base_browser_esm/* default */.Z)("div",  true ? {
  target: "e1dszmc2"
} : 0)( true ? "" : 0);
var ButtonWrapper = /*#__PURE__*/(0,emotion_styled_base_browser_esm/* default */.Z)("div",  true ? {
  target: "e1dszmc1"
} : 0)( true ? "" : 0);
var DisclaimerWrapper = /*#__PURE__*/(0,emotion_styled_base_browser_esm/* default */.Z)("div",  true ? {
  target: "e1dszmc0"
} : 0)( true ? "" : 0);
// EXTERNAL MODULE: ../../node_modules/@emotion/react/jsx-runtime/dist/emotion-react-jsx-runtime.browser.esm.js
var emotion_react_jsx_runtime_browser_esm = __webpack_require__(52903);
;// CONCATENATED MODULE: ../../libs/templates/Forms/DemoForm/DemoForm.tsx


var _excluded = ["appearance", "className", "before", "after", "isProgressive", "isLeadEnrichmentFormEnabled", "overrideConsent", "customFormIdentifier", "customTrackingType", "successMessageAppearance", "onEmailCompleted", "buttonText", "customDisclaimer", "driftCampaignId", "successMessage"];

function ownKeys(object, enumerableOnly) {
  var keys = Object.keys(object);

  if (Object.getOwnPropertySymbols) {
    var symbols = Object.getOwnPropertySymbols(object);
    enumerableOnly && (symbols = symbols.filter(function (sym) {
      return Object.getOwnPropertyDescriptor(object, sym).enumerable;
    })), keys.push.apply(keys, symbols);
  }

  return keys;
}

function _objectSpread(target) {
  for (var i = 1; i < arguments.length; i++) {
    var source = null != arguments[i] ? arguments[i] : {};
    i % 2 ? ownKeys(Object(source), !0).forEach(function (key) {
      (0,defineProperty/* default */.Z)(target, key, source[key]);
    }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) {
      Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
    });
  }

  return target;
}
/* eslint-disable react-hooks/exhaustive-deps */





























var MOBILE_OFFSET = -150;
var DESKTOP_OFFSET = -350;
var FORM_ID = "demo-form"; // Set up demo form props since we define some of these props here in the template

var DemoForm = function DemoForm(_ref) {
  var appearance = _ref.appearance,
      className = _ref.className,
      before = _ref.before,
      after = _ref.after,
      _ref$isProgressive = _ref.isProgressive,
      isProgressive = _ref$isProgressive === void 0 ? false : _ref$isProgressive,
      _ref$isLeadEnrichment = _ref.isLeadEnrichmentFormEnabled,
      isLeadEnrichmentFormEnabled = _ref$isLeadEnrichment === void 0 ? true : _ref$isLeadEnrichment,
      _ref$overrideConsent = _ref.overrideConsent,
      overrideConsent = _ref$overrideConsent === void 0 ? true : _ref$overrideConsent,
      customFormIdentifier = _ref.customFormIdentifier,
      customTrackingType = _ref.customTrackingType,
      successMessageAppearance = _ref.successMessageAppearance,
      onEmailCompleted = _ref.onEmailCompleted,
      _ref$buttonText = _ref.buttonText,
      buttonText = _ref$buttonText === void 0 ? "Get a demo" : _ref$buttonText,
      customDisclaimer = _ref.customDisclaimer,
      driftCampaignId = _ref.driftCampaignId,
      customSuccessMessage = _ref.successMessage,
      rest = (0,objectWithoutProperties/* default */.Z)(_ref, _excluded);

  var _usePageConfig = (0,page/* usePageConfig */.Gm)(),
      baseUrl = _usePageConfig.baseUrl;

  var theme = (0,emotion_element_6a883da9_browser_esm.u)();
  var formAppearance = (0,AppearanceContext/* useAppearance */.M)(appearance);
  var countryCode = (0,useLocation/* default */.Z)(); // Initialize form here since we need the form initialized to handle progressive fields and the personal email functionality

  var _useState = (0,react.useState)(false),
      emailCompleted = _useState[0],
      setEmailCompleted = _useState[1];

  var _useState2 = (0,react.useState)(undefined),
      intPhoneErrorCode = _useState2[0],
      setIntPhoneErrorCode = _useState2[1];

  var _useState3 = (0,react.useState)(),
      submittedEmail = _useState3[0],
      setSubmittedEmail = _useState3[1];
  /* eslint-disable camelcase */


  var schema = (0,react.useMemo)(function () {
    var _z$object;

    return lib/* object */.Ry((_z$object = {
      email: lib/* string */.Z_({
        required_error: FormFields/* companyEmailMessages.required */.BN.required
      }).regex(regexes_form/* default */.Z, {
        message: FormFields/* companyEmailMessages.invalid */.BN.invalid
      }).regex(email/* default */.Z, {
        message: FormFields/* companyEmailMessages.invalid */.BN.invalid
      })
      /* This is equal to .email( { message: companyEmailMessages.invalid }) but with a custom regex */
      .regex(sharedEmail/* default */.C, {
        message: FormFields/* companyEmailMessages.invalid */.BN.invalid
      }).regex(forbiddenEmail, {
        message: FormFields/* companyEmailMessages.forbiddenEmail */.BN.forbiddenEmail
      }),
      name: lib/* string */.Z_({
        required_error: FormFields/* fullNameMessages.required */.aZ.required
      }).regex(regexes_form/* default */.Z, {
        message: FormFields/* fullNameMessages.invalid */.aZ.invalid
      }).regex(lastName/* default */.Z, {
        message: FormFields/* fullNameMessages.invalid */.aZ.invalid
      }),
      phone: lib/* string */.Z_({
        invalid_type_error: FormFields/* phoneNumberMessages.invalid */.NJ.invalid
      }).min(1, FormFields/* phoneNumberMessages.required */.NJ.required).refine(function () {
        return intPhoneErrorCode === undefined;
      }, {
        message: (0,FormFields/* getPhoneErrorMessage */.AP)(intPhoneErrorCode)
      })
    }, (0,defineProperty/* default */.Z)(_z$object, FormFields/* TWILIO_PHONE_VALID_FIELD */.tj, lib/* string */.Z_().optional()), (0,defineProperty/* default */.Z)(_z$object, FormFields/* TWILIO_PHONE_ERRORS_FIELD */.q5, lib/* string */.Z_().optional()), (0,defineProperty/* default */.Z)(_z$object, FormFields/* TWILIO_PHONE_CALLING_COUNTRY_CODE */.iZ, lib/* string */.Z_().optional()), (0,defineProperty/* default */.Z)(_z$object, FormFields/* TWILIO_PHONE_COUNTRY_CODE */.$l, lib/* string */.Z_().optional()), (0,defineProperty/* default */.Z)(_z$object, FormFields/* TWILIO_PHONE_NUMBER */.SZ, lib/* string */.Z_().optional()), (0,defineProperty/* default */.Z)(_z$object, FormFields/* TWILIO_PHONE_NATIONAL_FORMAT */.UN, lib/* string */.Z_().optional()), (0,defineProperty/* default */.Z)(_z$object, "company", lib/* string */.Z_({
      required_error: FormFields/* companyNameMessages.required */.qx.required
    }).regex(regexes_form/* default */.Z, {
      message: FormFields/* companyNameMessages.invalid */.qx.invalid
    })), _z$object));
  }, [intPhoneErrorCode]);
  /* eslint-enable camelcase */

  var methods = (0,index_esm/* useForm */.cI)({
    mode: "onBlur",
    reValidateMode: "onBlur",
    shouldUnregister: true,
    resolver: (0,zod/* zodResolver */.F)(schema)
  }); // Watch for personal email

  var watchedEmail = methods === null || methods === void 0 ? void 0 : methods.watch("email", ""); // If this is the progressive version of the form, set up email watching
  // Otherwise just always return true

  var showProgressiveFields = isProgressive ? Boolean(watchedEmail || emailCompleted) : true; // Mobile breakpoints

  var mobileResolutionMediaQuery = theme.breakpoints.down("md", false);
  var isSmallResolution = (0,useMatchMedia/* default */.Z)(mobileResolutionMediaQuery, true);
  (0,react.useEffect)(function () {
    if (watchedEmail) {
      setEmailCompleted(true);
      if (onEmailCompleted) onEmailCompleted();
    }
  }, [watchedEmail]);
  var successMessage = customSuccessMessage || {
    heading: "Thank you, you\u2019re all set!",
    description: "We'll get back to you shortly. For now, you can create your workspace by clicking below.",
    buttonUrl: "".concat(baseUrl, "/signup/?utm_campaign=demo"),
    buttonText: "Create your free workspace"
  };

  var collectDriftFormData = function collectDriftFormData(formData) {
    var unTypedWindow = window;

    if (unTypedWindow.drift) {
      unTypedWindow.drift.api.collectFormData(_objectSpread(_objectSpread({}, formData), {}, {
        firstName: formData.name.split(" ")[0],
        lastName: formData.name.split(" ").slice(1).join(" ")
      }), {
        campaignId: driftCampaignId
      });
    }
  };

  (0,react.useEffect)(function () {
    if (methods.getValues("phone")) {
      methods.trigger("phone");
    }
  }, [intPhoneErrorCode]);
  return (0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)(AppearanceContext/* AppearanceProvider */.x, {
    appearance: formAppearance,
    children: [(0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(FormWrapper, {
      id: FORM_ID,
      children: (0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)(TrackableForm/* default */.Z, _objectSpread(_objectSpread({
        gap: "small",
        methods: methods,
        className: className,
        before: before,
        after: after,
        success: isLeadEnrichmentFormEnabled ? (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(emotion_react_jsx_runtime_browser_esm/* Fragment */.HY, {}) : (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(FormSubmitAction/* default */.Z, _objectSpread({
          form: "demo",
          status: "success",
          appearance: successMessageAppearance,
          "data-hook": "demo-signup-success-message"
        }, successMessage)),
        error: (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(FormSubmitAction/* default */.Z, _objectSpread({
          form: "demo",
          status: "error",
          "data-hook": "demo-form-error-message"
        }, TrackableForm/* errorMessage */.N)),
        onSubmit: function onSubmit(data) {
          setSubmittedEmail(data.email);
          (0,helpers/* createDemoLead */.Ii)(data);

          if (driftCampaignId) {
            collectDriftFormData(data);
          }

          if (isSmallResolution && showProgressiveFields) {
            (0,useScrollToAnchor/* scrollToAnchor */.d)(FORM_ID, MOBILE_OFFSET, false);
          } else {
            (0,useScrollToAnchor/* scrollToAnchor */.d)(FORM_ID, DESKTOP_OFFSET, false);
          }
        },
        onFailure: helpers/* trackValidationErrorDemoForm */.nR,
        overrideConsent: overrideConsent,
        customFormIdentifier: customFormIdentifier,
        customTrackingType: customTrackingType
      }, rest), {}, {
        children: [(0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(FormFields/* CompanyEmailField */.Ot, {
          onBlur: helpers/* trackValidationErrorDemoForm */.nR
        }), showProgressiveFields && (0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)(emotion_react_jsx_runtime_browser_esm/* Fragment */.HY, {
          children: [(0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(FormFields/* FullNameField */.AM, {
            onBlur: helpers/* trackValidationErrorDemoForm */.nR
          }), (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(FormFields/* PhoneNumberField */.g8, {
            countryCode: countryCode,
            onValidate: setIntPhoneErrorCode,
            onBlur: helpers/* trackValidationErrorDemoForm */.nR
          }), (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(FormFields/* CompanyNameField */.wA, {
            onBlur: helpers/* trackValidationErrorDemoForm */.nR
          })]
        }), customFormIdentifier && (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(FormFields/* CustomFormIdentifierField */.Fe, {
          value: customFormIdentifier
        }), (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(ButtonWrapper, {
          children: (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(Button/* default */.Z, {
            color: "primary",
            variant: "filled",
            size: "large",
            expanded: true,
            children: buttonText
          })
        }), showProgressiveFields && (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(DisclaimerWrapper, {
          children: (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(Disclaimer/* default */.Z, {
            data: customDisclaimer,
            appearance: successMessageAppearance
          })
        })]
      }))
    }), isLeadEnrichmentFormEnabled && methods.formState.isSubmitSuccessful && (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(ProgressiveProfileForm/* ProgressiveProfileForm */.u, {
      before: (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(FormSubmitMessage/* FormSubmitMessage */.f, {
        status: "success",
        form: "demo"
      }),
      email: submittedEmail,
      successMessage: successMessage
    })]
  });
};
/* harmony default export */ var DemoForm_DemoForm = ((/* unused pure expression or super */ null && (DemoForm)));
;// CONCATENATED MODULE: ../../libs/templates/Forms/DemoForm/index.ts


/***/ }),

/***/ 6612:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "u": function() { return /* binding */ ProgressiveProfileForm; }
});

// UNUSED EXPORTS: default

// EXTERNAL MODULE: ../../node_modules/next/dist/compiled/@babel/runtime/helpers/esm/asyncToGenerator.js
var asyncToGenerator = __webpack_require__(20406);
// EXTERNAL MODULE: ../../node_modules/next/dist/compiled/@babel/runtime/helpers/esm/defineProperty.js
var defineProperty = __webpack_require__(95235);
// EXTERNAL MODULE: ../../node_modules/next/dist/compiled/@babel/runtime/helpers/esm/objectWithoutProperties.js + 1 modules
var objectWithoutProperties = __webpack_require__(82269);
// EXTERNAL MODULE: ../../node_modules/next/dist/compiled/@babel/runtime/regenerator/index.js
var regenerator = __webpack_require__(28526);
var regenerator_default = /*#__PURE__*/__webpack_require__.n(regenerator);
// EXTERNAL MODULE: ../../node_modules/react/index.js
var react = __webpack_require__(2784);
// EXTERNAL MODULE: ../../node_modules/react-hook-form/dist/index.esm.mjs
var index_esm = __webpack_require__(63955);
// EXTERNAL MODULE: ../../node_modules/zod/lib/index.mjs
var lib = __webpack_require__(30195);
// EXTERNAL MODULE: ../../node_modules/@hookform/resolvers/zod/dist/zod.mjs + 1 modules
var zod = __webpack_require__(88883);
// EXTERNAL MODULE: ../../libs/matcha/foundations/AppearanceContext/index.ts + 1 modules
var AppearanceContext = __webpack_require__(9381);
// EXTERNAL MODULE: ../../libs/matcha/components/Button/index.ts
var Button = __webpack_require__(33445);
// EXTERNAL MODULE: ../../libs/templates/FormFields/index.ts + 22 modules
var FormFields = __webpack_require__(53790);
// EXTERNAL MODULE: ../../libs/templates/Disclaimer/index.ts + 3 modules
var Disclaimer = __webpack_require__(80401);
// EXTERNAL MODULE: ../../libs/templates/FormSubmitAction/index.ts + 2 modules
var FormSubmitAction = __webpack_require__(17433);
// EXTERNAL MODULE: ../../libs/templates/FormFields/JobTitle.tsx
var JobTitle = __webpack_require__(96321);
// EXTERNAL MODULE: ../../libs/templates/FormFields/Timeline.tsx
var Timeline = __webpack_require__(12307);
// EXTERNAL MODULE: ../../libs/templates/FormFields/MonthlyTraffic.tsx
var MonthlyTraffic = __webpack_require__(75886);
// EXTERNAL MODULE: ../../libs/templates/FormFields/CompanySize.tsx
var CompanySize = __webpack_require__(20417);
// EXTERNAL MODULE: ../../libs/matcha/components/Input/index.ts + 2 modules
var Input = __webpack_require__(94261);
// EXTERNAL MODULE: ../../node_modules/@emotion/react/jsx-runtime/dist/emotion-react-jsx-runtime.browser.esm.js
var emotion_react_jsx_runtime_browser_esm = __webpack_require__(52903);
;// CONCATENATED MODULE: ../../libs/templates/FormFields/HiddenEmail.tsx


var _excluded = ["type", "name", "id", "className", "dataHook", "value"];

function ownKeys(object, enumerableOnly) {
  var keys = Object.keys(object);

  if (Object.getOwnPropertySymbols) {
    var symbols = Object.getOwnPropertySymbols(object);
    enumerableOnly && (symbols = symbols.filter(function (sym) {
      return Object.getOwnPropertyDescriptor(object, sym).enumerable;
    })), keys.push.apply(keys, symbols);
  }

  return keys;
}

function _objectSpread(target) {
  for (var i = 1; i < arguments.length; i++) {
    var source = null != arguments[i] ? arguments[i] : {};
    i % 2 ? ownKeys(Object(source), !0).forEach(function (key) {
      (0,defineProperty/* default */.Z)(target, key, source[key]);
    }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) {
      Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
    });
  }

  return target;
}




/**
 * Email hidden input for demo forms
 */

var HiddenEmailField = function HiddenEmailField(_ref) {
  var _ref$type = _ref.type,
      type = _ref$type === void 0 ? "hidden" : _ref$type,
      _ref$name = _ref.name,
      name = _ref$name === void 0 ? "email" : _ref$name,
      _ref$id = _ref.id,
      id = _ref$id === void 0 ? "email" : _ref$id,
      className = _ref.className,
      dataHook = _ref.dataHook,
      value = _ref.value,
      rest = (0,objectWithoutProperties/* default */.Z)(_ref, _excluded);

  var _useFormContext = (0,index_esm/* useFormContext */.Gc)(),
      register = _useFormContext.register;

  return (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(Input/* default */.Z, _objectSpread(_objectSpread({
    "data-testid": "email",
    className: className,
    id: id,
    type: type,
    "data-hook": dataHook,
    value: value
  }, register(name, {})), rest));
};
// EXTERNAL MODULE: ../../libs/templates/TrackableForm/index.ts + 5 modules
var TrackableForm = __webpack_require__(53100);
// EXTERNAL MODULE: ../../libs/tracking/scripts/helpers.ts
var helpers = __webpack_require__(753);
// EXTERNAL MODULE: ../../libs/utils/useScrollToAnchor/index.ts
var useScrollToAnchor = __webpack_require__(68714);
// EXTERNAL MODULE: ../../libs/utils/regexes/form.ts
var regexes_form = __webpack_require__(63535);
// EXTERNAL MODULE: ../../libs/contexts/demo.tsx
var demo = __webpack_require__(805);
// EXTERNAL MODULE: ../../libs/contexts/page.ts
var page = __webpack_require__(17782);
// EXTERNAL MODULE: ../../node_modules/@emotion/styled/base/dist/emotion-styled-base.browser.esm.js
var emotion_styled_base_browser_esm = __webpack_require__(92952);
;// CONCATENATED MODULE: ../../libs/templates/Forms/ProgressiveProfileForm/ProgressiveProfileForm.views.tsx


function _EMOTION_STRINGIFIED_CSS_ERROR__() {
  return "You have tried to stringify object returned from `css` function. It isn't supposed to be used directly (e.g. as value of the `className` prop), but rather handed to emotion so it can handle it (e.g. as value of `css` prop).";
}

var FormWrapper = /*#__PURE__*/(0,emotion_styled_base_browser_esm/* default */.Z)("div",  true ? {
  target: "ebdrtja1"
} : 0)( true ? {
  name: "1flj9lk",
  styles: "text-align:left"
} : 0);
var ButtonWrapper = /*#__PURE__*/(0,emotion_styled_base_browser_esm/* default */.Z)("div",  true ? {
  target: "ebdrtja0"
} : 0)( true ? "" : 0);
;// CONCATENATED MODULE: ../../libs/templates/Forms/ProgressiveProfileForm/ProgressiveProfileForm.tsx



var ProgressiveProfileForm_excluded = ["appearance", "className", "before", "after", "overrideConsent", "customFormIdentifier", "successMessageAppearance", "email", "successMessage"];


function ProgressiveProfileForm_ownKeys(object, enumerableOnly) {
  var keys = Object.keys(object);

  if (Object.getOwnPropertySymbols) {
    var symbols = Object.getOwnPropertySymbols(object);
    enumerableOnly && (symbols = symbols.filter(function (sym) {
      return Object.getOwnPropertyDescriptor(object, sym).enumerable;
    })), keys.push.apply(keys, symbols);
  }

  return keys;
}

function ProgressiveProfileForm_objectSpread(target) {
  for (var i = 1; i < arguments.length; i++) {
    var source = null != arguments[i] ? arguments[i] : {};
    i % 2 ? ProgressiveProfileForm_ownKeys(Object(source), !0).forEach(function (key) {
      (0,defineProperty/* default */.Z)(target, key, source[key]);
    }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ProgressiveProfileForm_ownKeys(Object(source)).forEach(function (key) {
      Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
    });
  }

  return target;
}
























var BUTTON_TEXT = "Let's get started";
/* eslint-disable camelcase */

var schema = lib/* object */.Ry({
  jobTitle: lib/* string */.Z_({
    required_error: JobTitle/* jobTitleMessages.required */.cY.required
  }).regex(regexes_form/* default */.Z, {
    message: JobTitle/* jobTitleMessages.invalid */.cY.invalid
  }),
  companySize: lib/* string */.Z_({
    required_error: CompanySize/* companySizeMessages.required */.CF.required
  }),
  monthlyTraffic: lib/* string */.Z_({
    required_error: MonthlyTraffic/* monthlyTrafficMessages.required */.dn.required
  }),
  timeline: lib/* string */.Z_({
    required_error: Timeline/* timelineMessages.required */.Cb.required
  }),
  email: lib/* string */.Z_().optional()
});
/* eslint-enable camelcase */
// Set up demo form props since we define some of these props here in the template

var ProgressiveProfileForm = function ProgressiveProfileForm(_ref) {
  var appearance = _ref.appearance,
      className = _ref.className,
      before = _ref.before,
      after = _ref.after,
      _ref$overrideConsent = _ref.overrideConsent,
      overrideConsent = _ref$overrideConsent === void 0 ? true : _ref$overrideConsent,
      customFormIdentifier = _ref.customFormIdentifier,
      successMessageAppearance = _ref.successMessageAppearance,
      email = _ref.email,
      customSuccessMessage = _ref.successMessage,
      rest = (0,objectWithoutProperties/* default */.Z)(_ref, ProgressiveProfileForm_excluded);

  var _usePageConfig = (0,page/* usePageConfig */.Gm)(),
      baseUrl = _usePageConfig.baseUrl;

  var formAppearance = (0,AppearanceContext/* useAppearance */.M)(appearance);
  var scrollTo = (0,useScrollToAnchor/* default */.Z)("progressive-profile-form", -200);

  var _useContext = (0,react.useContext)(demo/* DemoContext */.d),
      setCompletedFormData = _useContext.setCompletedFormData; // Initialize form here since we need the form initialized to handle progressive fields and the personal email functionality


  var methods = (0,index_esm/* useForm */.cI)({
    mode: "onBlur",
    reValidateMode: "onBlur",
    shouldUnregister: true,
    resolver: (0,zod/* zodResolver */.F)(schema)
  });
  var successMessage = customSuccessMessage || {
    heading: "Thank you, you\u2019re all set!",
    description: "We'll get back to you shortly. For now, you can create your workspace by clicking below.",
    buttonUrl: "".concat(baseUrl, "/signup/?utm_campaign=demo"),
    buttonText: "Create your free workspace"
  };
  return (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(AppearanceContext/* AppearanceProvider */.x, {
    appearance: formAppearance,
    children: (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(FormWrapper, {
      id: "progressive-profile-form",
      children: (0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)(TrackableForm/* default */.Z, ProgressiveProfileForm_objectSpread(ProgressiveProfileForm_objectSpread({
        gap: "small",
        methods: methods,
        className: className,
        before: before,
        after: after,
        success: (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(FormSubmitAction/* default */.Z, ProgressiveProfileForm_objectSpread({
          form: "demo",
          status: "success",
          appearance: successMessageAppearance,
          "data-hook": "demo-signup-success-message",
          onButtonClick: function onButtonClick() {
            (0,helpers/* trackButtonClick */.kO)({
              buttonText: successMessage.buttonText,
              buttonId: "Workspace signup",
              targetUrl: successMessage.buttonUrl
            });
          }
        }, successMessage)),
        error: (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(FormSubmitAction/* default */.Z, ProgressiveProfileForm_objectSpread({
          status: "error"
        }, TrackableForm/* errorMessage */.N)),
        onSubmit: /*#__PURE__*/function () {
          var _ref2 = (0,asyncToGenerator/* default */.Z)( /*#__PURE__*/regenerator_default().mark(function _callee(data) {
            return regenerator_default().wrap(function _callee$(_context) {
              while (1) {
                switch (_context.prev = _context.next) {
                  case 0:
                    setCompletedFormData(data);
                    _context.next = 3;
                    return (0,helpers/* trackProgressiveProfileForm */.NX)(data);

                  case 3:
                    scrollTo();

                  case 4:
                  case "end":
                    return _context.stop();
                }
              }
            }, _callee);
          }));

          return function (_x) {
            return _ref2.apply(this, arguments);
          };
        }(),
        onFailure: helpers/* trackValidationErrorProgressiveProfileForm */.An,
        overrideConsent: overrideConsent,
        customFormIdentifier: customFormIdentifier
      }, rest), {}, {
        children: [(0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(JobTitle/* JobTitleField */.kL, {}), (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(CompanySize/* CompanySizeSelectField */.BQ, {}), (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(MonthlyTraffic/* MonthlyTrafficSelectField */.VW, {}), (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(Timeline/* TimelineSelectField */.fz, {}), customFormIdentifier && (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(FormFields/* CustomFormIdentifierField */.Fe, {
          value: customFormIdentifier
        }), email && (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(HiddenEmailField, {
          value: email
        }), (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(ButtonWrapper, {
          children: (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(Button/* default */.Z, {
            color: "primary",
            variant: "filled",
            size: "large",
            expanded: true,
            children: BUTTON_TEXT
          })
        }), (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(Disclaimer/* default */.Z, {
          appearance: successMessageAppearance
        })]
      }))
    })
  });
};
/* harmony default export */ var ProgressiveProfileForm_ProgressiveProfileForm = ((/* unused pure expression or super */ null && (ProgressiveProfileForm)));

/***/ }),

/***/ 42576:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
// ESM COMPAT FLAG
__webpack_require__.r(__webpack_exports__);

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "default": function() { return /* reexport */ GettingStarted; }
});

// EXTERNAL MODULE: ../../node_modules/next/dist/compiled/@babel/runtime/helpers/esm/defineProperty.js
var defineProperty = __webpack_require__(95235);
// EXTERNAL MODULE: ../../libs/matcha/components/Button/index.ts
var Button = __webpack_require__(33445);
// EXTERNAL MODULE: ../../libs/matcha/components/Icons/Common.ts + 14 modules
var Common = __webpack_require__(6580);
// EXTERNAL MODULE: ../../libs/matcha/recipes/CopyText/index.ts + 2 modules
var CopyText = __webpack_require__(94136);
// EXTERNAL MODULE: ../../libs/matcha/recipes/SignupButton/index.ts
var SignupButton = __webpack_require__(77931);
// EXTERNAL MODULE: ../../libs/templates/LogoTiles/index.ts + 1 modules
var LogoTiles = __webpack_require__(20442);
// EXTERNAL MODULE: ../../libs/matcha/useDesignTokens/index.ts
var useDesignTokens = __webpack_require__(98439);
// EXTERNAL MODULE: ../../libs/utils/getAbsoluteUrl/getAbsoluteUrl.ts
var getAbsoluteUrl = __webpack_require__(43848);
// EXTERNAL MODULE: ../../libs/contexts/page.ts
var page = __webpack_require__(17782);
// EXTERNAL MODULE: ../../node_modules/@emotion/styled/base/dist/emotion-styled-base.browser.esm.js
var emotion_styled_base_browser_esm = __webpack_require__(92952);
;// CONCATENATED MODULE: ../../libs/templates/GettingStarted/GettingStarted.views.tsx

var Wrapper = /*#__PURE__*/(0,emotion_styled_base_browser_esm/* default */.Z)("div",  true ? {
  target: "e1044f9v2"
} : 0)("overflow-y:auto;overflow-x:hidden;padding-top:80px;background:", function (_ref) {
  var backgroundColor = _ref.backgroundColor;
  return backgroundColor;
}, ";" + ( true ? "" : 0));
var Copy = /*#__PURE__*/(0,emotion_styled_base_browser_esm/* default */.Z)("div",  true ? {
  target: "e1044f9v1"
} : 0)("display:grid;justify-content:center;row-gap:40px;padding:0 20px;", function (_ref2) {
  var theme = _ref2.theme;
  return theme.breakpoints.up("md");
}, "{padding:80px 80px 30px;}" + ( true ? "" : 0));
var Content = /*#__PURE__*/(0,emotion_styled_base_browser_esm/* default */.Z)("div",  true ? {
  target: "e1044f9v0"
} : 0)("display:grid;max-width:540px;width:100%;margin:0 auto;grid-template-columns:1fr 1fr;grid-template-rows:auto;gap:24px;", function (_ref3) {
  var theme = _ref3.theme;
  return theme.breakpoints.down("sm");
}, "{grid-template-columns:auto;max-width:327px;}" + ( true ? "" : 0));
// EXTERNAL MODULE: ../../node_modules/@emotion/react/jsx-runtime/dist/emotion-react-jsx-runtime.browser.esm.js
var emotion_react_jsx_runtime_browser_esm = __webpack_require__(52903);
;// CONCATENATED MODULE: ../../libs/templates/GettingStarted/GettingStarted.tsx


function ownKeys(object, enumerableOnly) {
  var keys = Object.keys(object);

  if (Object.getOwnPropertySymbols) {
    var symbols = Object.getOwnPropertySymbols(object);
    enumerableOnly && (symbols = symbols.filter(function (sym) {
      return Object.getOwnPropertyDescriptor(object, sym).enumerable;
    })), keys.push.apply(keys, symbols);
  }

  return keys;
}

function _objectSpread(target) {
  for (var i = 1; i < arguments.length; i++) {
    var source = null != arguments[i] ? arguments[i] : {};
    i % 2 ? ownKeys(Object(source), !0).forEach(function (key) {
      (0,defineProperty/* default */.Z)(target, key, source[key]);
    }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) {
      Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
    });
  }

  return target;
}













var BaseGettingStarted = function BaseGettingStarted(_ref) {
  var _ref$heading = _ref.heading,
      heading = _ref$heading === void 0 ? "Getting started is easy" : _ref$heading,
      _ref$description = _ref.description,
      description = _ref$description === void 0 ? "Start connecting your data with Segment." : _ref$description,
      _ref$demoUtms = _ref.demoUtms,
      demoUtms = _ref$demoUtms === void 0 ? "" : _ref$demoUtms,
      tokens = _ref.tokens;
  var pageConfig = (0,page/* usePageConfig */.Gm)();
  return (0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)(Wrapper, _objectSpread(_objectSpread({}, tokens), {}, {
    children: [(0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)(Copy, {
      children: [(0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)(CopyText/* default */.ZP, {
        centered: true,
        children: [(0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(CopyText/* Heading */.X6, {
          tag: "h3",
          variant: "h2",
          children: heading
        }), (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(CopyText/* Description */.dk, {
          tag: "p",
          variant: "pLarge",
          children: description
        })]
      }), (0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)(Content, {
        children: [(0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(Button/* default */.Z, {
          size: "large",
          color: "primary",
          variant: "filled",
          tag: "a",
          href: (0,getAbsoluteUrl/* default */.Z)("/demo/".concat(demoUtms), pageConfig),
          children: "Get a demo"
        }), (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(SignupButton/* default */.Z, {
          tag: "a",
          variant: "outlined",
          iconEnd: Common/* ChevronRightIcon */.XC,
          children: "Create a free account"
        })]
      })]
    }), (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(LogoTiles/* default */.Z, {})]
  }));
};

var GettingStarted = (0,useDesignTokens/* withDesignTokens */.Y)(BaseGettingStarted, function () {
  return {};
}, {
  light: function light(theme) {
    return {
      backgroundColor: theme.palette.neutrals.cloud[100]
    };
  },
  dark: function dark(theme) {
    return {
      backgroundColor: theme.palette.brand.darkAcai[700]
    };
  },
  twilioLight: function twilioLight(theme) {
    return {
      backgroundColor: theme.palette.twilio.gray[10]
    };
  }
});
;// CONCATENATED MODULE: ../../libs/templates/GettingStarted/index.ts


/***/ }),

/***/ 5099:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "Z": function() { return /* reexport */ Testimonial_Testimonial; }
});

// EXTERNAL MODULE: ../../libs/matcha/recipes/Testimonial/index.ts + 11 modules
var Testimonial = __webpack_require__(60814);
// EXTERNAL MODULE: ../../libs/utils/getAbsoluteUrl/getAbsoluteUrl.ts
var getAbsoluteUrl = __webpack_require__(43848);
// EXTERNAL MODULE: ../../libs/contexts/page.ts
var page = __webpack_require__(17782);
// EXTERNAL MODULE: ../../libs/matcha/foundations/Theme/index.ts + 30 modules
var Theme = __webpack_require__(46630);
// EXTERNAL MODULE: ../../libs/matcha/components/CompanyLogos/CompanyMono.ts + 250 modules
var CompanyMono = __webpack_require__(68536);
// EXTERNAL MODULE: ../../libs/matcha/components/CompanyLogos/Company.ts + 258 modules
var Company = __webpack_require__(13922);
// EXTERNAL MODULE: ../../node_modules/@emotion/react/jsx-runtime/dist/emotion-react-jsx-runtime.browser.esm.js
var emotion_react_jsx_runtime_browser_esm = __webpack_require__(52903);
;// CONCATENATED MODULE: ../../libs/templates/Testimonial/data.tsx





var data = [{
  company: "box",
  logoName: "Box",
  logo: (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(CompanyMono/* BoxMonoLogo */.Xb7, {
    color: Theme/* default.palette.neutrals.white.100 */.ZP.palette.neutrals.white[100]
  }),
  text: "\u201CCustomerAI Predictions has equipped Box\u2019s marketing team with the ability to forecast customer behavior to a degree that was simply unavailable to us before. We\u2019ve been able to explore segmenting our audience based on predictive traits like who is most likely to join us at in-person events or who is more likely to purchase, and this allows us to meet those people where they are in their customer journey.\u201D",
  name: "Chris Koehler",
  position: "CMO at Box"
}, {
  company: "vacasa",
  logoName: "Vacasa",
  logo: (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(CompanyMono/* VacasaMonoLogo */.Ciy, {
    color: Theme/* default.palette.neutrals.white.100 */.ZP.palette.neutrals.white[100]
  }),
  text: "\u201CTwilio and Segment enable Vacasa to understand the entire customer journey to more effectively deliver personalized messages to guests and remove friction from their vacation experience.\u201D",
  name: "G Scott",
  position: "Director of Marketing Analytics",
  extendedRate: "3x",
  extendedText: "more guest bookings with personalized campaigns",
  extendedLink: "/customers/vacasa/"
}, {
  company: "fox",
  logoName: "Fox",
  logo: (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(CompanyMono/* FoxMonoLogo */.xrs, {
    color: Theme/* default.palette.neutrals.white.100 */.ZP.palette.neutrals.white[100]
  }),
  text: "When you use any of our mobile apps, you should be greeted like an old friend. When we deliver an ad to you, it should be relevant. When we suggest content to you, it should be in line with your tastes. This is all thanks to Segment.",
  name: "Daryl Bowden",
  position: "Executive Vice President, Technology Platforms at FOX Corporation",
  extendedRate: "376",
  extendedRateSymbol: "",
  extendedText: "more visitors to FOX Sports \u201CFor You\u201D app"
}, {
  company: "bonobos",
  logoName: "Bonobos",
  logo: (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(CompanyMono/* BonobosMonoLogo */.Trx, {
    color: Theme/* default.palette.neutrals.white.100 */.ZP.palette.neutrals.white[100]
  }),
  text: "\u201CAs our business grows, it has become increasingly important to understand how online spend influences offline behavior, which Facebook and Segment have made possible.\u201C",
  name: "Micky Onvural",
  position: "Co-President",
  extendedRate: "3x",
  extendedText: "increase in offline purchases versus control group",
  extendedLink: "/customers/bonobos/"
}, {
  company: "ibm",
  logoName: "IBM",
  logo: (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(CompanyMono/* IbmMonoLogo */.cEr, {
    color: Theme/* default.palette.neutrals.white.100 */.ZP.palette.neutrals.white[100]
  }),
  text: "\u201CWith real-time integrated data flows from Segment, we can truly understand what people are doing with our platform.\u201D",
  name: "Nic Sauriol",
  avatar: "",
  position: "Software Development Leader",
  extendedRate: "70",
  extendedRateSymbol: "%",
  extendedText: "increase in revenue following a three-month customer messaging pilot program",
  extendedLink: "/customers/ibm/"
}, {
  company: "rugs-com",
  logoName: "Rugs.com",
  logo: (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(CompanyMono/* RugsComMonoLogo */.ONK, {
    color: Theme/* default.palette.neutrals.white.100 */.ZP.palette.neutrals.white[100]
  }),
  text: "\"Segment\u2019s first-party audience targeting capabilities directly improved our return on ad spend. With better performing Google and Facebook campaigns...we were able to reinvest part of our optimized ad budgets into other high growth initiatives.\u201D",
  name: "Grayson Bagwell",
  position: "Director of Business Development and E-Commerce",
  extendedRate: "400",
  extendedRateSymbol: "%",
  extendedText: "YoY revenue growth",
  extendedLink: "/customers/rugs-dot-com/"
}, {
  company: "digital-ocean",
  logoName: "DigitalOcean",
  logo: (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(CompanyMono/* DigitalOceanMonoLogo */.G7L, {
    color: Theme/* default.palette.neutrals.white.100 */.ZP.palette.neutrals.white[100]
  }),
  text: "\u201CSegment allows us to be more precise with how we dynamically suppress or target users in ad campaigns based on actual product usage.\u201D",
  name: "Sam Coren",
  position: "Senior Demand Generation Manager",
  extendedRate: "33",
  extendedRateSymbol: "%",
  extendedText: "improvement in cost per conversion",
  extendedLink: "/customers/digital-ocean/"
}, {
  company: "pager-duty",
  logoName: "PagerDuty",
  logo: (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(CompanyMono/* PagerDutyMonoLogo */.e90, {
    color: Theme/* default.palette.neutrals.white.100 */.ZP.palette.neutrals.white[100]
  }),
  text: "\u201CUsing Pendo and Segment to create this onboarding flow, rather than building it out as part of the core PagerDuty product, saves valuable time for engineering.\u201D",
  name: "Hailey Hickman",
  position: "Program Manager",
  extendedRate: "178",
  extendedRateSymbol: "%",
  extendedText: "increase in mobile app downloads",
  extendedLink: "/customers/pagerduty/"
}, {
  company: "drift",
  logoName: "Drift",
  logo: (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(CompanyMono/* DriftMonoLogo */.BPv, {
    color: Theme/* default.palette.neutrals.white.100 */.ZP.palette.neutrals.white[100]
  }),
  text: "\u201CWe're using Twilio Engage as our new-age CRM. We identify which prospects are most likely to convert by aggregating individual user intent signals for each account...\u201D",
  name: "Guillaume Cabane",
  position: "Former VP of Growth",
  extendedRateSymbol: "%",
  extendedRate: "150",
  extendedText: "increase in positive conversations in 2 months",
  extendedLink: "/customers/drift/"
}, {
  company: "dominos",
  logoName: "Domino's",
  logo: (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(CompanyMono/* DominosMonoLogo */.ooH, {
    color: Theme/* default.palette.neutrals.white.100 */.ZP.palette.neutrals.white[100]
  }),
  text: "Domino\u2019s turned to Twilio Segment to create a universal view of the customer, better visibility of ad campaign effectiveness, and create hyper personalized audiences with Twilio Engage to increase ROAS, revenue and incremental orders across all paid and owned e-commerce channels.",
  name: "",
  position: "Domino's",
  extendedRateSymbol: "%",
  extendedRate: "65",
  extendedText: "decrease in customer acquisition cost",
  extendedLink: "/customers/dominos/"
}, {
  company: "ab-in-bev",
  logoName: "ABInBev",
  logo: (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(CompanyMono/* AbInBevMonoLogo */.gud, {
    color: Theme/* default.palette.neutrals.white.100 */.ZP.palette.neutrals.white[100]
  }),
  text: "\u201COur products are vital to our customers\u2019 businesses, and through BEES we\u2019ve empowered them to order the products their consumers love anytime, anywhere. Couple this with real time messaging about when their products will arrive, and what changes have taken place in the process, if any, has deepened our relationship with our customers immensely.\u201D",
  name: "Jason Lambert",
  position: "SVP Product at BEES",
  extendedRateSymbol: "",
  extendedRate: "$2",
  extendedText: "businesses buzzing through a next generation B2B platform with Twilio Segment",
  extendedLink: "/customers/ab-inbev/"
}, {
  company: "crypto-com",
  logoName: "Crypto.com",
  logo: (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(CompanyMono/* CryptoComMonoLogo */.K9k, {
    color: Theme/* default.palette.neutrals.white.100 */.ZP.palette.neutrals.white[100]
  }),
  text: "\u201CWe knew from day one that Twilio\u2019s solutions were the most qualified because our developers had first-hand experience, knowledge, and success working with them in the past.\u201D",
  name: "Matthew Chan",
  position: "Chief Technology Officer",
  extendedRateSymbol: "%",
  extendedRate: "900",
  extendedText: "forecasted increase in user-base by 2023",
  extendedLink: "/customers/crypto/"
}, {
  company: "earnest",
  logoName: "Earnest",
  logo: (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(CompanyMono/* EarnestMonoLogo */.Iei, {
    color: Theme/* default.palette.neutrals.white.100 */.ZP.palette.neutrals.white[100]
  }),
  text: "\u201CTwilio Segment provided Earnest with a single user identity and consistent, granular customer data that the team needed to create the advanced, customized metrics to scale the affiliate program.\u201D",
  name: "Goutham Valeti",
  position: "Head of Analytics",
  extendedRate: "10x",
  extendedText: "loan volume growth and saved borrowers well over $100M",
  extendedLink: "/customers/earnest/"
}, {
  company: "clear-score",
  logoName: "ClearScore",
  logo: (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(CompanyMono/* ClearScoreMonoLogo */.Ojb, {
    color: Theme/* default.palette.neutrals.white.100 */.ZP.palette.neutrals.white[100]
  }),
  text: "\u201CThe cost of a Segment investment completely beat our in-house options out of the water. It was a no-brainer in terms of cost.\u201D",
  name: "Klaus Thorup",
  avatar: "",
  position: "Chief Technology Officer",
  extendedRate: "3x",
  extendedText: "cost savings with Twilio Segment instead of building in-house",
  extendedLink: "/customers/clearscore/"
}, {
  company: "toggle",
  logoName: "Toggle",
  logo: (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(CompanyMono/* ToggleMonoLogo */.nSO, {
    color: Theme/* default.palette.neutrals.white.100 */.ZP.palette.neutrals.white[100]
  }),
  text: "\u201CWhat we have in Segment is a platform for serendipity. We\u2019re able to react to many scenarios, innovate quickly, scale resources, and bolster a culture of digital transformation.\u201D",
  name: "Todd Wright",
  position: "Sr. Technologist",
  extendedRateSymbol: "%",
  extendedRate: "64",
  extendedText: "decrease in cost per acquisition",
  extendedLink: "/customers/toggle/"
}, {
  company: "stylepit",
  logoName: "Stylepit",
  logo: (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(CompanyMono/* StylepitMonoLogo */.$K_, {
    color: Theme/* default.palette.neutrals.white.100 */.ZP.palette.neutrals.white[100]
  }),
  text: "\"Segment proved to us that our first-party data was more valuable than any third-party data\u2014even third-party tracking cookies\u2014could provide.\"",
  name: "Martin Brummerstedt",
  position: "Data Scientist & Digital Project Manager",
  extendedRate: "1.7x",
  extendedText: "increase in ROAS",
  extendedLink: "/customers/stylepit/"
}, {
  company: "tradesy",
  logoName: "Tradesy",
  logo: (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(CompanyMono/* TradesyMonoLogo */.qKx, {
    color: Theme/* default.palette.neutrals.white.100 */.ZP.palette.neutrals.white[100]
  }),
  text: "\u201CWe played around and built a couple of prototypes for our own data pipeline, but we quickly realized that it would take three engineers six months to stabilize a platform, and even then it would not be as feature-rich as Segment.\u201D",
  name: "Geoff Apps",
  position: "CTO at Tradesy",
  extendedRate: "6",
  extendedText: "months saved in engineering time",
  extendedLink: "/customers/tradesy/"
}, {
  company: "frame-io",
  logoName: "FrameIo",
  logo: (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(CompanyMono/* FrameIoMonoLogo */.QzL, {
    color: Theme/* default.palette.neutrals.white.100 */.ZP.palette.neutrals.white[100]
  }),
  text: "\u201CFrame.io needed a definitive 'single source of truth' where they could unify diverse data sources that would provide the full picture of their customers and Twilio Segment provided that.\u201D",
  name: "Kyle Gesuelli",
  position: "Head of Growth",
  extendedRateSymbol: "%",
  extendedRate: 80,
  extendedText: "reduction in the handle time on support tickets",
  extendedLink: "/customers/frameio/"
}, {
  company: "retool",
  logoName: "Retool",
  logo: (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(CompanyMono/* RetoolMonoLogo */.U8Y, {
    color: Theme/* default.palette.neutrals.white.100 */.ZP.palette.neutrals.white[100]
  }),
  text: "\u201CAfter we looked at the costs of building the basic infrastructure and the support required, Twilio Segment became a no-brainer and we upgraded from their Startup Program.\u201D",
  name: "Jane Kelly",
  position: "Head of Growth",
  extendedRateSymbol: "",
  extendedRate: "1000+",
  extendedText: "Retool saved over 1,000 engineering hours by using Twilio Segment",
  extendedLink: "/customers/retool/"
}, {
  company: "meredith",
  logoName: "Meredith",
  logo: (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(CompanyMono/* MeredithMonoLogo */.eqZ, {
    color: Theme/* default.palette.neutrals.white.100 */.ZP.palette.neutrals.white[100]
  }),
  text: "\u201CSegment has enabled us to streamline the data capture process while maintaining flexibility to customize per brand as needed.\u201C",
  name: "Grace Preyapongpisan",
  position: "Vice President, Business Intelligence",
  extendedRate: 36,
  extendedText: "brands centralized on the same data analytics infrastructure",
  extendedLink: "/customers/meredith/"
}, {
  company: "candu",
  logoName: "Candu",
  logo: (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(CompanyMono/* CanduMonoLogo */.IBI, {
    color: Theme/* default.palette.neutrals.white.100 */.ZP.palette.neutrals.white[100]
  }),
  text: "\u201CThe developer experience with Segment was super easy. Docs were robust enough for us to follow and build an integration within a day.\u201C",
  name: "Michele Riccardo Esposito",
  position: "Chief Technology Officer"
}, {
  company: "looker",
  logoName: "Looker",
  logo: (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(CompanyMono/* LookerMonoLogo */.lpP, {
    color: Theme/* default.palette.neutrals.white.100 */.ZP.palette.neutrals.white[100]
  }),
  text: "\u201CHaving a consistent pipeline of clean and standardized first-party data from Segment is an extremely valuable and core data set for our customers\u2019 success.\u201C",
  name: "Keenan Rice",
  position: "VP Strategic Alliances"
}, {
  company: "trustpilot",
  logoName: "Trustpilot",
  logo: (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(CompanyMono/* TrustpilotMonoLogo */.OPh, {
    color: Theme/* default.palette.neutrals.white.100 */.ZP.palette.neutrals.white[100]
  }),
  text: "\u201CSegment\u2019s Privacy Portal gives us the confidence to align our event data streams with our company\u2019s data privacy and governance standards. With real-time visibility across our event streams, we are able to proactively respect our customers\u2019 privacy.\u201C",
  name: "Rudy Martin",
  position: "Chief Information Security Office"
}, {
  company: "adviso",
  logoName: "Adviso",
  logo: (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(CompanyMono/* AdvisoMonoLogo */.HXI, {
    color: Theme/* default.palette.neutrals.white.100 */.ZP.palette.neutrals.white[100]
  }),
  text: "\u201CWorking with Segment allows us to better serve our clients by delivering deeper insights, more quickly. Segment reduces time spent building data pipelines and allows us to provide access to reliable, clean, and actionable data to our customers.\u201C",
  name: "Louis-Philippe Mathieu",
  position: "Data Scientist"
}, {
  company: "prolific-interactive",
  logoName: "ProlificInteractive",
  logo: (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(CompanyMono/* ProlificInteractiveMonoLogo */.BDm, {
    color: Theme/* default.palette.neutrals.white.100 */.ZP.palette.neutrals.white[100]
  }),
  text: "\u201CSegment understands the value of having their end-users be experts on the platform, and that remains a top priority for them. Instead of simply doing it for you, they take the time to guide you to a deeper level of understanding of the nuances of their platform.\u201C",
  name: "David Reyneke",
  position: "Sr. Growth Manager"
}, {
  company: "y-combinator",
  logoName: "YCombinator",
  logo: (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(CompanyMono/* YCombinatorMonoLogo */.ah_, {
    color: Theme/* default.palette.neutrals.white.100 */.ZP.palette.neutrals.white[100]
  }),
  text: "\u201CSegment helps businesses set up analytics the way it was meant to be \u2014 quantifying product-market fit, understanding customers, and trying new tools \u2014 all without redundant or time-consuming work.\u201C",
  name: "Gustaf Alstr\xF6mer",
  position: "Partner at Y Combinator"
}, {
  company: "flowers-1800",
  logoName: "Flowers1800",
  logo: (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(CompanyMono/* Flowers1800MonoLogo */.QZv, {
    color: Theme/* default.palette.neutrals.white.100 */.ZP.palette.neutrals.white[100]
  }),
  text: "\u201CWith Twilio Engage, we are able to collect, unify and connect customer data in real time and build meaningful relationships at every touchpoint of the customer journey. We\u2019re accelerating our digital business and data infrastructure by nearly a decade, and by doing so, delighting our customers.\u201C",
  name: "Amit Shah",
  position: "President"
}, {
  company: "shutterstock",
  logoName: "Shutterstock",
  logo: (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(CompanyMono/* ShutterstockMonoLogo */.IcO, {
    color: Theme/* default.palette.neutrals.white.100 */.ZP.palette.neutrals.white[100]
  }),
  text: "Shutterstock partnered with Segment to unlock the personalization power for their email campaigns. Segment\u2019s expertise accelerated the digital media marketplace\u2019s customer experience with contextually relevant messaging and a 30% lift in click rates."
}, {
  company: "typeform",
  logoName: "Typeform",
  logo: (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(CompanyMono/* TypeformMonoLogo */.wJ3, {
    color: Theme/* default.palette.neutrals.white.100 */.ZP.palette.neutrals.white[100]
  }),
  text: "\u201CUntil we started standardizing our data, people didn\u2019t realize how messy it had become. With Protocols, we can be confident that data quality issues don\u2019t happen anymore.\u201D",
  name: "Colin Furlong",
  position: "Data Operations & Tracking",
  extendedRateSymbol: "%",
  extendedRate: 75,
  extendedText: "Reduction in duplicate or extraneous tracked events",
  extendedLink: "/customers/typeform/"
}, {
  company: "creative-market",
  logoName: "CreativeMarket",
  logo: (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(CompanyMono/* CreativeMarketMonoLogo */.w1t, {
    color: Theme/* default.palette.neutrals.white.100 */.ZP.palette.neutrals.white[100]
  }),
  text: "\u201CProtocols provides the context my teams need to effectively use our customer data in campaigns and analyses.\u201D",
  name: "Akshay Singh",
  position: "Former extended & Product Analytst",
  extendedRateSymbol: "%",
  extendedRate: 93,
  extendedText: "Reduction in time to detect data issues",
  extendedLink: "/customers/creative-market/"
}, {
  company: "allergan",
  logoName: "Allergan",
  logo: (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(CompanyMono/* AllerganMonoLogo */.ubl, {
    color: Theme/* default.palette.neutrals.white.100 */.ZP.palette.neutrals.white[100]
  }),
  text: "\u201CWe lean heavily on Segment today to identify our consumers and their profile traits, what makes them them, and what kind of journey they are on.\u201D",
  name: "Christine Li",
  position: "Director of Marketing Technology",
  extendedRate: "400M+",
  extendedText: "In sales driven in 2021 YTD by direct-to-consumer",
  extendedLink: "/customers/allergan/"
}, {
  company: "amboss",
  logo: (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(CompanyMono/* AmbossMonoLogo */.D9K, {
    color: Theme/* default.palette.neutrals.white.100 */.ZP.palette.neutrals.white[100]
  }),
  logoName: "Amboss",
  text: "\u201C[...]Twilio Segment has been game-changing, helping us to centralize our customer data far more quickly, efficiently and cost effectively than we could have imagined.\u201D",
  name: "Elmar Weber",
  position: "Chief Technical Officer",
  extendedText: "Reduced time to insights from days to minutes",
  extendedLink: "/customers/amboss/"
}, {
  company: "chopra",
  logoName: "Chopra",
  logo: (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(CompanyMono/* ChopraMonoLogo */.aIE, {
    color: Theme/* default.palette.neutrals.white.100 */.ZP.palette.neutrals.white[100]
  }),
  text: "\u201CTwilio Segment is significantly cheaper than having a full data team[...]and allowed us to see what our customers are actually doing.\u201D",
  name: "Josh Wexler",
  position: "Chief Product Officer",
  extendedText: "Maximized resources resulting in the building of data-driven products",
  extendedLink: "/customers/chopra/"
}, {
  company: "ritual",
  logoName: "Ritual",
  logo: (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(CompanyMono/* RitualMonoLogo */.qWP, {
    color: Theme/* default.palette.neutrals.white.100 */.ZP.palette.neutrals.white[100]
  }),
  text: "\u201CWe use Segment as our CDP and the biggest thing it\u2019s given us is flexibility[...]to define what the ideal experience is for our customers.\u201D",
  name: "Laura Brodie",
  position: "Director of Customer Lifecycle and Growth",
  extendedText: "More agile audience development and increased LTV over time",
  extendedLink: "/customers/ritual/"
}, {
  company: "theVintageBar",
  logoName: "TheVintageBar",
  logo: (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(CompanyMono/* TheVintageBarMonoLogo */.u$x, {
    color: Theme/* default.palette.neutrals.white.100 */.ZP.palette.neutrals.white[100]
  }),
  text: "\u201CSegment has empowered our company to make decisions smarter and faster to give our customers the best experience possible. With constant experimentation, sophisticated customer data models, and journey mapping, we can deliver personalization at scale and across all channels.\u201D",
  name: "Nikolaj Toxv\xE6rd",
  position: "Chief Marketing Officer",
  extendedRate: "6x",
  extendedText: "inventory growth in 6 months with optimized experiences",
  extendedLink: "/customers/the-vintage-bar/"
}, {
  company: "good-eggs",
  logoName: "GoodEggs",
  logo: (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(CompanyMono/* GoodeggsMonoLogo */.nCX, {
    color: Theme/* default.palette.neutrals.white.100 */.ZP.palette.neutrals.white[100]
  }),
  text: "\"Segment has proven not only to be simple, fast, and reliable \u2014 but also an accelerant. Engineering can now focus on features and use cases, rather than infrastructure to get our events from the edge to downstream systems.\"",
  name: "Bob Zoller",
  position: "Founding Engineer",
  extendedRate: "0 Hours",
  extendedText: "engineering time spend managing data pipelines",
  extendedLink: "/customers/goodeggs/"
}, {
  company: "halp",
  logoName: "Halp",
  logo: (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(CompanyMono/* HalpMonoLogo */.JRr, {
    color: Theme/* default.palette.neutrals.white.100 */.ZP.palette.neutrals.white[100]
  }),
  text: "\"Using Segment, you save a combination of time and money.\"",
  name: "Fletcher Richman",
  position: "CEO and Co-Founder",
  extendedRate: "4x",
  extendedText: "improvement in the number of activated sign-ups",
  extendedLink: "/customers/halp/"
}, {
  company: "craft-jack",
  logoName: "CraftJack",
  logo: (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(CompanyMono/* CraftJackMonoLogo */.Vsb, {
    color: Theme/* default.palette.neutrals.white.100 */.ZP.palette.neutrals.white[100]
  }),
  text: "\"With Twilio Engage, we are able to do the work of three or four different tools, all in one centralized platform. We are able to bring transactional conversation and personalized marketing messages all into Twilio Engage for greater efficiency.\"",
  name: "Jordan Dietch",
  position: "VP of Product Management, CraftJack",
  extendedText: "31% increase in new user signups YoY and 80% increase in engineering implementation efficiency",
  extendedLink: "/customers/craftjack/"
}, {
  company: "mongodb",
  logoName: "mongodb",
  logo: (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(CompanyMono/* MongoDbMonoLogo */.N2M, {
    color: Theme/* default.palette.neutrals.white.100 */.ZP.palette.neutrals.white[100]
  }),
  text: "\u201CSince implementing Segment we have seen a significant increase in revenue which we attribute to the improved targeting and personalization of our communications.\u201D"
}, {
  company: "sanofi",
  logoName: "sanofi",
  logo: (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(CompanyMono/* SanofiMonoLogo */.he8, {
    color: Theme/* default.palette.neutrals.white.100 */.ZP.palette.neutrals.white[100]
  }),
  text: "\u201CThe process before Segment was much more cumbersome and difficult to explain to marketers. Now, Segment allows us to compile data all in one place, forming a Golden Profile, and allows for other teams to easily utilize and activate data.\u201D"
}, {
  company: "the-motley-fool",
  logoName: "the-motley-fool",
  logo: (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(CompanyMono/* TheMotleyFoolMonoLogo */.DeK, {
    color: Theme/* default.palette.neutrals.white.100 */.ZP.palette.neutrals.white[100]
  }),
  text: "\u201CTwilio Segment is much more of a self-service platform. Whereas before we were limited in how we could message or target prospects and members, we can now build and activate audiences almost immediately.\u201D"
}, {
  company: "univision",
  logoName: "univision",
  logo: (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(CompanyMono/* UnivisionMonoLogo */.KML, {
    color: Theme/* default.palette.neutrals.white.100 */.ZP.palette.neutrals.white[100]
  }),
  text: "\u201CRegardless of scale, Segment provides you the tools and platform to move quickly and efficiently. We couldn\u2019t\n    have done this any other way.\u201C"
}, {
  company: "crossfit",
  logoName: "crossfit",
  logo: (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(CompanyMono/* CrossFitMonoLogo */.DvB, {
    color: Theme/* default.palette.neutrals.white.100 */.ZP.palette.neutrals.white[100]
  }),
  text: "\u201CNow, our data and teams are cohesive and connected, we can make data driven decisions and reach our customers\n    effectively.\u201C"
}, {
  company: "arduino",
  logoName: "arduino",
  logo: (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(CompanyMono/* ArduinoMonoLogo */.Yt2, {
    color: Theme/* default.palette.neutrals.white.100 */.ZP.palette.neutrals.white[100]
  }),
  text: "\u201CA big benefit of Segment is being able to activate our first-party data all in one platform. Our previous\n    tool required more manual effort, and therefore limited our marketing communication options\u201C"
}, {
  company: "fender",
  logoName: "Fender",
  text: "To increase adoption and retention rates, Fender also uses tools from Twilio Segment to optimize the customer\n    sales funnel by streamlining the onboarding process.",
  logo: (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(CompanyMono/* FenderMonoLogo */.bf1, {
    color: Theme/* default.palette.neutrals.white.100 */.ZP.palette.neutrals.white[100]
  }),
  name: "",
  position: "",
  extendedRate: "29%",
  extendedText: "reduction in customer churn rate for paid app",
  extendedLink: "/customers/fender"
}, {
  company: "trademe",
  logoName: "TradeMe",
  logo: (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(CompanyMono/* TradeMeMonoLogo */.KH, {
    color: Theme/* default.palette.neutrals.white.100 */.ZP.palette.neutrals.white[100]
  }),
  text: "\u201CThe marketing team has been making very good use of CustomerAI Predictions, and we are keen on continuing to use it to drive campaigns across digital channels.\u201D"
}, {
  company: "camping-world",
  logoName: "CampingWorld",
  logo: (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(CompanyMono/* CampingWorldMonoLogo */.H1r, {
    color: Theme/* default.palette.neutrals.white.100 */.ZP.palette.neutrals.white[100]
  }),
  text: "\u201CTwilio Engage allows Camping World to track events like \u2018RV model viewed\u2019 and \u2018RV added to favorites list\u2019 to create profiles, then utilize this information to craft specific omni-channel messages.\u201D"
}, {
  company: "adevinta",
  logoName: "Adevinta",
  logo: (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(CompanyMono/* AdevintaMonoLogo */.fGv, {
    color: Theme/* default.palette.neutrals.white.100 */.ZP.palette.neutrals.white[100]
  }),
  text: "With Segment at its core, Adevinta will enable cross-organizational collaboration through standardized data leading to relevant, personalized customer touch points across all its channels."
}, {
  company: "vervoe",
  logoName: "Vervoe",
  logo: (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(CompanyMono/* VervoeMonoLogo */.VhY, {
    color: Theme/* default.palette.neutrals.white.100 */.ZP.palette.neutrals.white[100]
  }),
  text: "\u201CWe rely on Segment pretty heavily to feed all of the platforms to understand where the breakdowns are within the customer journey.\u201D"
}, {
  company: "tillster",
  logoName: "Tillster",
  logo: (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(CompanyMono/* TillsterMonoLogo */.Tys, {
    color: Theme/* default.palette.neutrals.white.100 */.ZP.palette.neutrals.white[100]
  }),
  text: "\u201CWith Segment, we are able to use more personalization and intelligent targeting\u201C"
}, {
  company: "smartcar",
  text: (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(emotion_react_jsx_runtime_browser_esm/* Fragment */.HY, {
    children: "\u201CBuilding a user-friendly API isn\u2019t always easy\u2014especially if you want to appeal to your users and their users. Thanks to Twilio Segment, we can focus on both areas in one go, and give our team the chance to measure and evaluate the things they feel are most important.\u201D"
  }),
  name: "Sanketh Katta",
  position: "CTO and co-founder, Smartcar",
  logo: (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(CompanyMono/* SmartcarMonoLogo */.DXF, {
    color: Theme/* default.palette.neutrals.white.100 */.ZP.palette.neutrals.white[100]
  }),
  logoActive: (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(Company/* SmartcarLogo */.GQ7, {}),
  logoName: "Smartcar",
  extendedRate: "22%",
  extendedText: "improvement in developer application conversions",
  extendedLink: "/customers/smartcar/"
}, {
  company: "lens-online",
  text: (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(emotion_react_jsx_runtime_browser_esm/* Fragment */.HY, {
    children: "\u201CWhile our previous tech stack, including a CRM, SAP, Zendesk, etc. supported our early growth, it wasn't enough for our future ambitions. We needed to not just understand but anticipate our customer's needs. This realization led us to Twilio Segment, moving beyond traditional CRMs to a 360-degree view of customers, integrating every customer interaction and preference with a customer data platform.\u201D"
  }),
  name: "Pascal",
  position: "CMO & CDO, LensOnline",
  logo: (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(CompanyMono/* LensOnlineMonoLogo */.FRf, {
    color: Theme/* default.palette.neutrals.white.100 */.ZP.palette.neutrals.white[100]
  }),
  logoActive: (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(Company/* LensOnlineLogo */.vmS, {}),
  logoName: "Fender",
  extendedRate: "15%",
  extendedText: "reduction in marketing spend",
  extendedLink: "/customers/lens-online/"
}, {
  company: "veronica-beard",
  text: (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(emotion_react_jsx_runtime_browser_esm/* Fragment */.HY, {
    children: "\u201CBased on our research, we know that omnichannel customers are our most valuable customers. Because of this, we build Twilio Engage Audiences of our omnichannel customers and top customers in lifetime revenue, to use as the basis for lookalike audiences in Facebook Ads.\u201D"
  }),
  name: "Maxime Lagresle",
  position: "Ecommerce Analytics Manager",
  logo: (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(CompanyMono/* VeronicaBeardMonoLogo */.i_T, {
    color: Theme/* default.palette.neutrals.white.100 */.ZP.palette.neutrals.white[100]
  }),
  logoName: "VeronicaBeard",
  extendedRate: "20% ",
  extendedText: "Reduction in customer acquisition costs (CAC) from Facebook Ads",
  extendedLink: "/customers/veronica-beard/"
}];
;// CONCATENATED MODULE: ../../libs/templates/Testimonial/Testimonial.tsx







var TestimonialTemplate = function TestimonialTemplate(_ref) {
  var _ref$variant = _ref.variant,
      variant = _ref$variant === void 0 ? "base" : _ref$variant,
      _ref$height = _ref.height,
      height = _ref$height === void 0 ? variant === "extended" ? "460px" : "auto" : _ref$height,
      overrides = _ref.overrides,
      company = _ref.company,
      color = _ref.color,
      logo = _ref.logo,
      text = _ref.text,
      avatar = _ref.avatar,
      name = _ref.name,
      position = _ref.position,
      extendedRate = _ref.extendedRate,
      extendedRateSymbol = _ref.extendedRateSymbol,
      extendedText = _ref.extendedText,
      extendedLink = _ref.extendedLink;
  var pageConfig = (0,page/* usePageConfig */.Gm)();
  var companyData = data.find(function (item) {
    return item.company === company;
  });
  return (0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)(Testimonial/* default */.ZP, {
    variant: variant,
    children: [(0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)(Testimonial/* Base */.XY, {
      color: color || (companyData === null || companyData === void 0 ? void 0 : companyData.color),
      overrides: overrides,
      height: height,
      children: [(0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)(Testimonial/* BaseContentSlot */.b6, {
        children: [(0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(Testimonial/* BaseLogo */.jo, {
          children: (companyData === null || companyData === void 0 ? void 0 : companyData.logo) || logo
        }), (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(Testimonial/* BaseText */.k$, {
          children: text || (companyData === null || companyData === void 0 ? void 0 : companyData.text)
        })]
      }), (name || (companyData === null || companyData === void 0 ? void 0 : companyData.name)) && (0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)(Testimonial/* BaseAuthorSlot */.hC, {
        children: [(avatar || (companyData === null || companyData === void 0 ? void 0 : companyData.avatar)) && (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(Testimonial/* AuthorAvatar */.DV, {
          alt: "Portrait of" + name,
          src: avatar || String(companyData === null || companyData === void 0 ? void 0 : companyData.avatar)
        }), (0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)(Testimonial/* AuthorInfo */.d7, {
          children: [(0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(Testimonial/* AuthorName */.U2, {
            children: name || (companyData === null || companyData === void 0 ? void 0 : companyData.name)
          }), (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(Testimonial/* AuthorPosition */.a6, {
            children: position || (companyData === null || companyData === void 0 ? void 0 : companyData.position)
          })]
        })]
      })]
    }), variant === "extended" && (0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)(Testimonial/* Extended */.jW, {
      children: [(0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)(Testimonial/* ExtendedTextSlot */.VJ, {
        children: [(extendedRate || (companyData === null || companyData === void 0 ? void 0 : companyData.extendedRate)) && (0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)(Testimonial/* ExtendedHeader */.S2, {
          color: color || (companyData === null || companyData === void 0 ? void 0 : companyData.color),
          children: [extendedRate || (companyData === null || companyData === void 0 ? void 0 : companyData.extendedRate), (extendedRateSymbol || (companyData === null || companyData === void 0 ? void 0 : companyData.extendedRateSymbol)) && (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(Testimonial/* ExtendedHeaderSup */.Jk, {
            children: extendedRateSymbol || (companyData === null || companyData === void 0 ? void 0 : companyData.extendedRateSymbol)
          })]
        }), (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(Testimonial/* ExtendedText */.wN, {
          children: extendedText || (companyData === null || companyData === void 0 ? void 0 : companyData.extendedText)
        })]
      }), (extendedLink || (companyData === null || companyData === void 0 ? void 0 : companyData.extendedLink)) && (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(Testimonial/* ExtendedButtonSlot */.Wi, {
        children: (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(Testimonial/* ExtendedStoryLink */.c9, {
          children: (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(Testimonial/* ExtendedButton */.Di, {
            colored: Boolean(color),
            href: (0,getAbsoluteUrl/* default */.Z)(extendedLink || (companyData === null || companyData === void 0 ? void 0 : companyData.extendedLink) || "", pageConfig),
            text: "Read their story"
          })
        })
      })]
    })]
  });
};

/* harmony default export */ var Testimonial_Testimonial = (TestimonialTemplate);
;// CONCATENATED MODULE: ../../libs/templates/Testimonial/index.ts


/***/ }),

/***/ 51895:
/***/ (function(__unused_webpack_module, __webpack_exports__) {

"use strict";
var lastName = /^(?![\s\S]*\s[;,?=+\-@])[^;,?=+\-@\s][\s\S]+$/g;
/* harmony default export */ __webpack_exports__["Z"] = (lastName);

/***/ }),

/***/ 85807:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "Z": function() { return /* reexport */ useInView; }
});

// EXTERNAL MODULE: ../../node_modules/react/index.js
var react = __webpack_require__(2784);
;// CONCATENATED MODULE: ../../libs/utils/useInView/useInView.ts

/**
 * A hook to observe elements in the viewport
 * @param ref - A ref to the element to observe
 * @param options - The options for the IntersectionObserver
 * @returns A boolean indicating if the element is in the viewport
 */

var useIsInView = function useIsInView(ref) {
  var _ref = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {},
      _ref$stopOnIntersecti = _ref.stopOnIntersection,
      stopOnIntersection = _ref$stopOnIntersecti === void 0 ? true : _ref$stopOnIntersecti,
      options = _ref.options;

  var _useState = (0,react.useState)(false),
      isInView = _useState[0],
      setIsInView = _useState[1];

  var inViewRef = (0,react.useRef)(false);
  (0,react.useEffect)(function () {
    var intersectionObserver = new IntersectionObserver(function (intersection) {
      if (intersection.some(function (i) {
        return i.isIntersecting;
      })) {
        inViewRef.current = true;
        setIsInView(true);

        if (stopOnIntersection) {
          intersectionObserver.disconnect();
        }
      } else if (inViewRef.current) {
        inViewRef.current = false;
        setIsInView(false);
      }
    }, options);

    if (ref.current) {
      intersectionObserver.observe(ref.current);
    }

    return function () {
      intersectionObserver.disconnect();
    };
  }, [ref]);
  return isInView;
};

/* harmony default export */ var useInView = (useIsInView);
;// CONCATENATED MODULE: ../../libs/utils/useInView/index.ts


/***/ }),

/***/ 62016:
/***/ (function(__unused_webpack_module, __unused_webpack_exports, __webpack_require__) {


    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/solutions/ai/customerai-predictions",
      function () {
        return __webpack_require__(92090);
      }
    ]);
    if(false) {}
  

/***/ }),

/***/ 31305:
/***/ (function(module) {

module.exports = "/_next/static/images/OgImage-8214d2e34f9cb02edd71e7af5df73d81.jpg";

/***/ }),

/***/ 75855:
/***/ (function(module) {

module.exports = "/_next/static/images/DiscoverAndActivate@2x-d248092f60758e3bce19433f56d339dd.png";

/***/ }),

/***/ 63988:
/***/ (function(module) {

module.exports = "/_next/static/images/Hero@2x-dae61c28aebbecea0809f0e3ce33c3c0.png";

/***/ }),

/***/ 92941:
/***/ (function(module) {

module.exports = "/_next/static/images/PredictiveAIModels@2x-2acc10c3f7d408d84cd15392afd082d2.png";

/***/ }),

/***/ 94582:
/***/ (function(module) {

module.exports = "/_next/static/images/PredictiveAudiences@2x-9fec498fe86cd9cff2f2b3537bdba8ae.png";

/***/ }),

/***/ 24631:
/***/ (function(module) {

module.exports = "/_next/static/images/DashboardExplore@2x-74418018609bdfeb7a3f0e1855c9dec5.png";

/***/ }),

/***/ 57692:
/***/ (function(module) {

module.exports = "/_next/static/images/DashboardUnderstand@2x-b6c1ba64df0351a650a60d828eb1efdf.png";

/***/ }),

/***/ 86331:
/***/ (function(module) {

module.exports = "/_next/static/images/DiscoverAndActivate-d8f985865f730650b11efd57b74d5b89.webp";

/***/ }),

/***/ 13675:
/***/ (function(module) {

module.exports = "/_next/static/images/DiscoverAndActivate@2x-52438fcd3f31fe4ddacb25fbdff87f4e.webp";

/***/ }),

/***/ 39493:
/***/ (function(module) {

module.exports = "/_next/static/images/Hero-ed480203783e54701b1abf503a0c6e48.webp";

/***/ }),

/***/ 24217:
/***/ (function(module) {

module.exports = "/_next/static/images/Hero@2x-b62f877a0cc4b04ba4f0734653e98dae.webp";

/***/ }),

/***/ 20625:
/***/ (function(module) {

module.exports = "/_next/static/images/PredictiveAIModels-f0134a5ed0404a99a6bc16bc10ea1414.webp";

/***/ }),

/***/ 96256:
/***/ (function(module) {

module.exports = "/_next/static/images/PredictiveAIModels@2x-25380b4bb8eefff295c14ba8176e8cd7.webp";

/***/ }),

/***/ 12019:
/***/ (function(module) {

module.exports = "/_next/static/images/PredictiveAudiences-dbdd18b6983d9220cc3452016277b173.webp";

/***/ }),

/***/ 6758:
/***/ (function(module) {

module.exports = "/_next/static/images/PredictiveAudiences@2x-ccc63e9afeb324bd6ccb9145023bffaf.webp";

/***/ }),

/***/ 80681:
/***/ (function(module) {

module.exports = "/_next/static/images/DashboardExplore@2x-a3d002cbf6269e48fd4e3a253208f40b.webp";

/***/ }),

/***/ 92122:
/***/ (function(module) {

module.exports = "/_next/static/images/DashboardUnderstand-5e7eea34598247b9abcca2e9518855e1.webp";

/***/ }),

/***/ 88669:
/***/ (function(module) {

module.exports = "/_next/static/images/DashboardUnderstand@2x-c1f35e980e3f41d8615b7e707d9ddff3.webp";

/***/ })

},
/******/ function(__webpack_require__) { // webpackRuntimeModules
/******/ var __webpack_exec__ = function(moduleId) { return __webpack_require__(__webpack_require__.s = moduleId); }
/******/ __webpack_require__.O(0, [3287,9097,6577,3607,9137,3254,9129,1382,4136,8392,2073,7096,2429,7303,4488,948,3996,8187,8726,7960,6012,442,3922,8536,3379,4881,2065,814,9774,2888,179], function() { return __webpack_exec__(62016); });
/******/ var __webpack_exports__ = __webpack_require__.O();
/******/ _N_E = __webpack_exports__;
/******/ }
]);